import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CommonService} from '../../../services/common/common.service';
import {MediaManagerService} from '../../../services/media-manager/media-manager.service';
import {UploadService} from '../../../services/upload/upload.service';
import {ThreadPostService} from '../../../services/thread-post/thread-post.service';
import {ThreadService} from '../../../services/thread/thread.service';
import {AnnouncementService} from 'src/app/services/announcement/announcement.service';
import {HttpEvent, HttpEventType, HttpClient} from '@angular/common/http';
import {NgbActiveModal, NgbModal, NgbModalConfig} from '@ng-bootstrap/ng-bootstrap';
import {NgxImageCompressService} from 'ngx-image-compress';
import {forumPageAccess, IsOpenNewTab, MediaTypeInfo, MediaTypeSizes, PlatFormType, RedirectionPage} from '../../../common/constant/constant';
import {UploadExistingComponent} from 'src/app/components/common/upload-existing/upload-existing.component';
import {ConfirmationComponent} from 'src/app/components/common/confirmation/confirmation.component';
import {MediaUploadComponent} from 'src/app/components/media-upload/media-upload.component';
import {SuccessModalComponent} from '../../../components/common/success-modal/success-modal.component';
import {DomSanitizer} from '@angular/platform-browser';
import {KnowledgeBaseService} from 'src/app/services/knowledge-base/knowledge-base.service';
import {LandingpageService} from 'src/app/services/landingpage/landingpage.service';
import {BaseService} from 'src/app/modules/base/base.service';
import {GtsService} from 'src/app/services/gts/gts.service';
import {ApiService} from 'src/app/services/api/api.service';
import {RepairOrderService} from 'src/app/services/repair-order/repair-order.service';
import { generateVideoThumbnails } from '@rajesh896/video-thumbnails-generator';
import {MessageService} from 'primeng/api';
import { environment } from 'src/environments/environment';

import heic2any from 'heic2any'; // Import the library
@Component({
  selector: 'app-file-attachment',
  templateUrl: './file-attachment.component.html',
  styleUrls: ['./file-attachment.component.scss'],
  providers: [MessageService]
})
export class FileAttachmentComponent implements OnInit {

  @Input() apiData: Object;
  @Input() attachmentItems: any = [];
  @Input() postData: any = [];
  @Input() action: string;
  @Input() pushData: any = '';
  @Input() approveStatusData: any = '';
  @Input() cloudTabApplyData: any = '';
  @Input() addLinkBool: any = true;
  @Input() acceptArray: any = "";
  @Input() fromMedia: boolean = false;
  @Input() isGts: boolean = false;
  @Input() instantUpload: boolean = false;
  @Output() uploadedItems: EventEmitter<any> = new EventEmitter();
  @Output() uploadComplete: EventEmitter<any> = new EventEmitter();
  @Output() surveyAttachments: EventEmitter<any> = new EventEmitter();
  @Output() roUploadComplete: EventEmitter<any> = new EventEmitter();
  @Output() toolDocumentUploadComplete: EventEmitter<any> = new EventEmitter();

  public units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  title = 'ng-bootstrap-modal-demo';
  errorMsg: string = 'Media Already Exist';
  closeResult: string;

  filesArr: any;
  waitingFiles: any = 0;
  uploadedFiles: any[] = [];
  attachments: any[] = [];
  existingFileIndex: any = [];
  existingFileAttachment: any = [];
  existingFiles: any[] = [];
  existingUploadFiles: any[] = [];
  progressInfos = [];
  uploadFileLength: number;
  public setupInitFile: number = 0;
  public pageAccess: string = '';
  public chooseLable: string = 'Files From PC';
  public chooseIcon: string = 'pi pi-paperclip';
  public showUpload: boolean = false;
  public showCancel: boolean = false;
  public attachmentView: boolean = false;
  public attachmentProgress: boolean = false;
  public addLinkFlag: boolean = true;
  public fileLoading: boolean = false;
  public checkingMedia: boolean = false;
  public loadingUploadImageInit: boolean = false;
  public collabticDomain: boolean = false;
  public collabticAutoDomain: boolean = false;
  public tvsDomain: boolean = false;
  public newThreadView: boolean = false;
  public progress = 0;
  public percentDone = 0;
  public totalSizeToUpload = 0;
  public loadedSoFar = 0;
  public actionIndex: any = -1;
  public successMsg: string = 'Uploading...';
  public successFlag: boolean = false;
  public closeDialog: boolean = false;
  public msgModalRef;
  public videoInterval: any;
  public heicImageInterval: any;
  public videoFlagInterval: any;
  public gtsAttachmentResponse: any = [];
  public existingMediaItems: any = [];

  public assetPath: string = 'assets/images';
  public mediaPath: string = `${this.assetPath}/media`;
  public mediaManagerPath: string = `${this.mediaPath}/manager`;
  public mediaIcon: string = 'media-active-icon.png';
  public linkIcon: string = 'link-icon.png';

  public imageSize: number = parseInt(MediaTypeSizes.fileSize);
  public videoSize: number = parseInt(MediaTypeSizes.fileSize);
  public audioSize: number = parseInt(MediaTypeSizes.fileSize);
  public docSize: number = parseInt(MediaTypeSizes.fileSize);
  public fileSizeTxt: string = MediaTypeSizes.fileSizeTxt;
  public processingTxt: string = MediaTypeInfo.ProcessingTxt;

  public customError: any = [];
  public invalidFileText: string = 'Invalid file size';
  public maxUploadText: string = 'maximum upload size is';
  public uploadFlag: any = null;
  public jobStatusFlag: any = null;
  public mediaConfig: any = {backdrop: 'static', keyboard: false, centered: true, windowClass: 'attachment-modal'};
  public modalConfig: any = {backdrop: 'static', keyboard: false, centered: true, windowClass: 'custom-modal'};
  public existModalConfig: any = {backdrop: 'static', keyboard: false, centered: true, windowClass: 'exist-modal'};
  public existModalHideConfig: any = {backdrop: 'static', keyboard: false, centered: true, windowClass: 'exist-modal hide', backdropClass: 'hide-backdrop'};
  public teamSystem = localStorage.getItem('teamSystem');
  @Input() isUpoladButtonShow: boolean = false;
  public inc = 0;
  public roPaymentUpload: boolean = false;
  public deleteImg: string = '';
  multipleSelect: boolean = true;
  private serverUrl: string;

  public mediaConvertFlag: boolean = false;
  public mediaConvertFlagOthers: boolean = false;
  public uploadProcesssInterval: any;

  imageUrl: string | ArrayBuffer | null = null;

  public heicImageConverted: boolean = false;
  private partSize = 2000 * 1024 * 1024; // 2 GB

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private baseSerivce: BaseService,
    public acticveModal: NgbActiveModal,
    private modalService: NgbModal,
    private config: NgbModalConfig,
    private imageCompress: NgxImageCompressService,
    private commonApi: CommonService,
    private mediaApi: MediaManagerService,
    private threadApi: ThreadService,
    private ancApi: AnnouncementService,
    private threadPostService: ThreadPostService,
    private uploadService: UploadService,
    public sanitizer: DomSanitizer,
    private kbApi: KnowledgeBaseService,
    private LandingpagewidgetsAPI: LandingpageService,
    public gtsApi: GtsService,
    public apiUrl: ApiService,
    private repairOrderApi: RepairOrderService,
    private messageService: MessageService,
    private http: HttpClient,
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
    config.size = 'dialog-centered';
  }

  ngOnInit(): void {
    console.log(this.uploadedFiles);
    console.log(this.action);
    console.log(this.apiData);

    let url = this.router.url.split('/');

    let platformId = localStorage.getItem('platformId');
    let domainId = localStorage.getItem('domainId');    

    this.collabticDomain = (platformId == PlatFormType.Collabtic) ? true : false;
    this.tvsDomain = (platformId == '2' && domainId == '52') ? true : false;
    this.mediaIcon = (this.tvsDomain) ? 'media-gray-icon.png' : this.mediaIcon;
    this.mediaIcon = this.apiUrl.attachmentNewPOPUP ? 'media-black-icon.png' : this.mediaIcon;
    this.linkIcon = this.apiUrl.attachmentNewPOPUP ? 'link-black-icon.png' : this.linkIcon;
    this.newThreadView = localStorage.getItem('threadView') == '1' ? true : false;
    let industryType = this.commonApi.getIndustryType();
    this.collabticAutoDomain = (this.collabticDomain && industryType.id == 2) ? true : false;

    let msize = localStorage.getItem('uploadMaxSize');
    let mText = localStorage.getItem('uploadMaxSizeText');

    this.imageSize = (msize != 'undefined' && msize != undefined) ? parseInt(msize) : parseInt(MediaTypeSizes.fileSize);
    this.videoSize = (msize != 'undefined' && msize != undefined) ? parseInt(msize) : parseInt(MediaTypeSizes.fileSize);
    this.audioSize = (msize != 'undefined' && msize != undefined) ? parseInt(msize) : parseInt(MediaTypeSizes.fileSize);
    this.docSize = (msize != 'undefined' && msize != undefined) ? parseInt(msize) : parseInt(MediaTypeSizes.fileSize);
    this.fileSizeTxt = (mText != 'undefined' && mText != undefined) ? mText : MediaTypeSizes.fileSizeTxt;

    console.log('this.apiData[access]',this.apiData['access']);

    // audio and video new approach update
    this.mediaConvertFlag = localStorage.getItem('mediaConvertFlag') == '1' ? true : false; 
                // must include the page access name for only access new approach update  
                this.mediaConvertFlag = this.mediaConvertFlag && (this.apiData['access'] == 'thread' || this.apiData['access'] == 'market-place'  || this.apiData['access'] == 'post' || this.apiData['access'] == 'documents' || this.apiData['access'] == 'annoncements' || this.apiData['access'] == 'parts' || this.apiData['access'] == 'knowledgearticles' ||  this.apiData['access'] == 'annoncements' ||  this.apiData['access'] == 'workorder-page' || this.apiData['access'] == 'instant-est-job' || this.apiData['access'] == 'presets' || this.apiData['access'] == 'adas-procedure' || this.apiData['access'] == 'adas' || this.apiData['access'] == 'tool-document-page' || this.apiData['access'] == 'ppfr') ? true : false;
     
    // image and other documents new approach update    
    this.mediaConvertFlagOthers = localStorage.getItem('mediaConvertFlagOthers') == '1' ? true : false; // image and other documents new approach update
    // must include the page access name for only access new approach update  
    this.mediaConvertFlagOthers = this.mediaConvertFlagOthers && (this.apiData['access'] == 'thread' || this.apiData['access'] == 'market-place'  || this.apiData['access'] == 'post' || this.apiData['access'] == 'documents' || this.apiData['access'] == 'annoncements' || this.apiData['access'] == 'parts' || this.apiData['access'] == 'knowledgearticles' ||  this.apiData['access'] == 'annoncements' ||  this.apiData['access'] == 'workorder-page' || this.apiData['access'] == 'instant-est-job' || this.apiData['access'] == 'presets' || this.apiData['access'] == 'adas-procedure' || this.apiData['access'] == 'adas' || this.apiData['access'] == 'tool-document-page' || this.apiData['access'] == 'ppfr') ? true : false;
    
     if(this.action == 'edit') {
      let access = this.apiData['access'];
      let postAttachments = [];
      let existItem = '';
      switch (access) {
        case 'thread':
        case 'market-place':
        case 'market-place-survey':
          existItem = 'threadAttachments';
          break;
        case 'presets':
          existItem = 'presetsAttachments';
          break;
        case 'opportunity':
          existItem = 'opportunityAttachments';
          break;
        case 'documents':
          existItem = 'docAttachments';
          break;
        case 'knowledgearticles':
          existItem = 'knowledgeArticlesAttachments';
          break;
        case 'parts':
          existItem = 'partAttachments';
          break;
        case 'adas':
        case 'adas-procedure':
            existItem = 'adasAttachments';
            break;
        case 'post':
          console.log(this.postData);
          let postId = this.postData.postId;
          let threadId = this.postData.threadId;
          let threadPostText = `thread-post-${threadId}-attachments`;
          let postAttachmentItems: any = localStorage.getItem(threadPostText);
          postAttachmentItems = (postAttachmentItems) ? JSON.parse(postAttachmentItems) : [];
          let postIndex = postAttachmentItems.findIndex(option => option.id == postId);
          postAttachments = (postIndex < 0) ? [] : postAttachmentItems[postIndex].attachments;
          break;
      }
      this.existingMediaItems = (access == 'post') ? postAttachments : JSON.parse(localStorage.getItem(existItem));
    }
    this.commonApi.uploadInfoDataReceivedSubject.subscribe(
      (r) => {
        setTimeout(() => {
          this.setupFileSelection(r);
        }, 1);
      });

    this.pageAccess = this.apiData['access'];
    console.log(this.pageAccess);
    this.actionIndex = this.apiData['actionIndex'];
    this.uploadFileLength = this.uploadedFiles.length;
    switch (this.action) {
      case 'uploading':
        this.uploadedFiles = this.apiData['uploadedItems'];
        this.attachments = this.apiData['attachments'];
        console.log(this.uploadedFiles);
        console.log(this.attachments);
        this.attachmentUpload();
        break;
      case 'attachments':
        this.attachments = this.apiData['attachmentItems'];
        break;
      case 'media-apply':
        this.uploadedFiles = this.apiData['uploadedItems'];
        this.attachments = this.apiData['attachments'];
        console.log(this.uploadedFiles);
        console.log(this.attachments);
        this.mediaApply();
        break;
      default:
        console.log(this.apiData);
        if (this.apiData['uploadedItems'] != undefined) {
          this.uploadedFiles = this.apiData['uploadedItems'];
          this.uploadFileLength = this.uploadedFiles.length;
          if (this.uploadFileLength > 0) {
            this.uploadedFiles = this.apiData['uploadedItems'];
            this.attachments = this.apiData['attachments'];
            this.attachmentView = true;
            this.fileLoading = !this.attachmentView;
          }
        }
        break;
    }

    if(this.pageAccess == 'welcome-message'){
      this.chooseLable = "Upload Image/Video";
    }
    if(this.pageAccess == 'video-library'){
      this.chooseLable = "Video From PC";
    }
    if(this.pageAccess == 'ro-payment-upload'){
      this.roPaymentUpload = true;
      this.deleteImg = this.roPaymentUpload ? "assets/images/delete-green-circle.png" : "assets/images/delete-circle.png" ;
    };

    if (this.apiData?.['access'] == 'video-library') {
      this.multipleSelect = false;
    } else {
      this.multipleSelect = true;
    }
    
  }

  setupFileSelection(r){
    this.uploadedFiles = r.items;
    this.attachments = r.attachments;
    console.log(this.uploadedFiles);
    console.log(this.attachments);
    this.attachmentProgress = false;
    this.attachmentView = false;
    this.fileLoading = !this.attachmentView;
    setTimeout(() => {
      this.attachmentView = true;
      this.fileLoading = !this.attachmentView;
      let uploadItems = {
        action: 'upload',
        items: this.uploadedFiles,
        attachments: this.attachments
      };
      console.log(uploadItems);
      this.uploadedItems.emit(uploadItems);
    },100);
  }

  // On Select File Upload
  onUpload(event) {
    
    if((this.apiData['access'] == 'market-place' && (this.apiData['domainId'] != 71 && this.apiData['domainId'] != 515) && this.apiData['trainingMode'] == "Recorded") || this.apiData['access'] == 'video-library' ) {
      let fileType = event.files[0].type.split('/');
      if(fileType[0] != 'video') {
        this.messageService.add({ severity: 'error', summary: 'Only videos are allowed', closable: false, life: 2500 });
        return
      };

     };

     if (this.apiData['access'] == 'video-library' && (this.attachments.length > 0 || (this.attachmentItems && this.attachmentItems.length > 0) )) {
      this.messageService.add({ severity: 'error', summary: 'You have already uploaded a video', closable: false, life: 2500 });
        return;
     }

   this.customError = [];
    console.log(this.apiData);
    this.uploadedFiles = (this.uploadedFiles == undefined) ? [] : this.uploadedFiles;
    let i = 0;
    this.attachmentView = false;
    this.fileLoading = !this.attachmentView;
    this.uploadFileLength = this.uploadedFiles.length;
    this.filesArr = event;
    console.log(this.filesArr);
    let fileLen = event.files.length;
    this.waitingFiles = fileLen;
    let isEstJob = (this.apiData['isEstJob'] && this.apiData['isEstJob'] != undefined) ? this.apiData['isEstJob'] : 0;
    for (let file of event.files) {
      console.log(file);
      let checkUploadFile = file;
      let flag = true;
      let fileType = file.type.split('/');
      let fileExtn = file.name.split('.').pop();
      let fileAttachment = [];
      let fname = file.name;
      let displayOrder = this.apiData['displayOrder'] + i;
      let lastDot = fname.lastIndexOf('.');
      let fileName = fname.substring(0, lastDot);
      let fileIndex = i + 1;
      let flagId = this.getFlagId(file);
      let base64File:any = '';
      file['bulkFile'] = false;
      file['flagId'] = flagId;
      console.log(this.attachments);
      if (this.attachments.length > 0) {
        for (let a of this.attachments) {
          console.log(fileName, a.fileCaption, fname, file.name);
          if (fileName == a.fileCaption || (fname == a.originalName && a.accessType == 'upload')) {
            flag = false;
            this.fileLoading = flag;
            this.invalidFileText = this.errorMsg;
            this.setErrMsg(fname, -1);
          }
        }
      }
      fileAttachment['audioDesc'] = false;
      fileAttachment['audioCaption'] = file.name;
      fileAttachment['originalfileArray'] = file;
      fileAttachment['fileId'] = 0;
      fileAttachment['mediaId'] = 0;
      fileAttachment['accessType'] = 'upload';
      fileAttachment['accessTypeText'] = 'From PC';
      fileAttachment['fileType'] = file.type;
      fileAttachment['fileSize'] = file.size;
      fileAttachment['originalName'] = file.name;
      fileAttachment['originalFileName'] = file.name;
      fileAttachment['newFileName'] = '';
      fileAttachment['bulkFile'] = false;
      //fileAttachment['fileCaption'] = fileName;
      fileAttachment['fileCaption'] = '';
      fileAttachment['captionFlag'] = false;
      fileAttachment['action'] = 'new';
      fileAttachment['progress'] = 0;
      fileAttachment['cancelFlag'] = false;
      fileAttachment['valid'] = true;
      fileAttachment['language'] = '';
      fileAttachment['itemValues'] = [];
      fileAttachment['selectedLang'] = [];
      fileAttachment['filteredLangItems'] = [];
      fileAttachment['filteredLangList'] = [];
      fileAttachment['fileDuration'] = 0;
      fileAttachment['uploadType'] = 'upload';
      fileAttachment['binaryfile'] = file;
      fileAttachment['isEstJob'] = isEstJob;

      file['language'] = '';
      file['fileCaption'] = fileName;
      file['captionFlag'] = false;
      file['displayOrder'] = this.uploadFileLength + displayOrder;
      if (flag && !this.instantUpload) {
        this.checkingMedia = true;
        let mediaFlag;
        const mediaFormData = new FormData();
        mediaFormData.append('apiKey', this.apiData['apiKey']);
        mediaFormData.append('domainId', this.apiData['domainId']);
        mediaFormData.append('countryId', this.apiData['countryId']);
        mediaFormData.append('userId', this.apiData['userId']);
        mediaFormData.append('fileName', file.name.replace(/'/g, ''));
        mediaFormData.append('fileType', file.type);
        if (this.isGts) {
          mediaFormData.append('newMedia', '1');
        }
        this.mediaApi.checkMediaName(mediaFormData).subscribe((response) => {
          this.waitingFiles -= 1;
          console.log(response, this.waitingFiles);
          mediaFlag = (response.status == 'Success') ? true : false;
          if(this.pageAccess == 'welcome-message'){
            mediaFlag = true;
          }
          if(this.pageAccess == 'ro-payment-upload'){
            mediaFlag = true;
          }
          if(this.pageAccess == 'workorder'){
            mediaFlag = true;
          }
          let msg = response.result;
          let mitem = response.mediaData;
          let existFlag = false;
          if(mitem != null) {
            console.log(this.existingMediaItems)
            if(this.existingMediaItems){
              let existIndex = this.existingMediaItems.findIndex(option => option.mediaId == mitem.mediaId);
              if(existIndex >= 0) {
                this.invalidFileText = msg;
                this.setErrMsg(fname, -1);
                existFlag = true;
              }
            }
          }
          console.log(mediaFlag);
          if (!mediaFlag) {
            //this.invalidFileText = msg;
            //this.setErrMsg(fname, -1);
            console.log(mitem);
            if (mitem == null) {
              this.invalidFileText = msg;
              this.setErrMsg(fname, -1);
            } else {
              let mindex = this.attachments.findIndex(option => option.fileId == mitem.mediaId);
              if (mindex < 0) {
                if(existFlag) {
                  this.filesArr.currentFiles.splice(fileIndex, 1);
                } else {
                  let eindex = fileIndex-1;
                  //this.setupMediaUploadFiles(mitem, 'exists', file);
                  fileAttachment['existIndex'] = eindex;
                  mitem['existIndex'] = eindex;
                  file['existIndex'] = eindex;
                  this.existingFileIndex.push(eindex);
                  this.existingFileAttachment.push(fileAttachment);
                  this.existingFiles.push(mitem);
                  this.existingUploadFiles.push(file);
                }
              }
            }
            console.log(fileLen, i, fileIndex, this.waitingFiles);
            if (this.waitingFiles == 0) {
              setTimeout(() => {
                this.checkingMedia = false;
                this.attachmentView = true;
                this.fileLoading = !this.attachmentView;
                if (this.attachments.length > 1) {
                  let checkArr = ['originalFileName'];
                  let unique = this.commonApi.unique(this.attachments, checkArr);
                  //this.attachments = unique;
                }
                let uploadItems = {
                  action: 'upload',
                  items: this.uploadedFiles,
                  attachments: this.attachments,
                  postData: this.postData,
                };
                console.log(uploadItems);
                this.uploadedItems.emit(uploadItems);
              }, 1000);
            }
          } else {
            if (this.waitingFiles == 0) {
              setTimeout(() => {
                this.checkingMedia = false;
                this.loadingUploadImageInit = true;
              }, 1000);
            }
            this.initFileUpload(file, fileIndex, fileLen, fileAttachment, i);
          }
          if(!existFlag && this.waitingFiles == 0 && this.existingFiles.length > 0) {
            setTimeout(() => {
              setTimeout(() => {
                let upLen = this.uploadedFiles.length;
                const modalRef = this.modalService.open(UploadExistingComponent, this.pageAccess == 'adasCalproReport' ? this.existModalHideConfig : this.existModalConfig);
                modalRef.componentInstance.access = '';
                modalRef.componentInstance.pageAccess = this.pageAccess;
                modalRef.componentInstance.existingItems = this.existingFiles;
                modalRef.componentInstance.mediaItems = this.existingUploadFiles;
                modalRef.componentInstance.apiData = this.apiData;
                modalRef.componentInstance.uploadAction.subscribe((receivedService) => {
                  console.log(receivedService, this.existingFileIndex)
                  let sflag = true;
                  let emitFlag = (this.instantUpload) ? false : true;
                  let scount = 0;
                  let emitAction = receivedService.action;
                  let emitMediaItems = [];
                  switch(emitAction) {
                    case 'submit':
                      let existingItems = receivedService.existingItems;
                      let uploadedFiles = receivedService.mediaItems;
                      this.existingFileIndex.forEach(eindex => {
                        let index = existingItems.findIndex(option => option.existIndex == eindex)
                        console.log(index, existingItems[index])
                        let fileIndex = index;
                        let fileAttachment = this.existingFileAttachment[index];
                        let maction = existingItems[index]['mediaAction'];
                        switch(maction) {
                          case 'current':
                            let mitem = existingItems[index];
                            if(!this.instantUpload) {
                              this.setupMediaUploadFiles(mitem, 'exists', uploadedFiles[index]);
                            } else {
                              emitFlag = true;
                              emitMediaItems.push(mitem);
                            }
                            break;
                          case 'replace':
                            fileAttachment['mediaId'] = uploadedFiles[index].mediaId;
                            console.log(fileAttachment);
                            this.initFileUpload(uploadedFiles[index], fileIndex, fileLen, fileAttachment, i);
                            break;
                          case 'new':
                            fileIndex = index;
                            let mfileExtn = fileAttachment['originalFileName'].split('.').pop();
                            let mfileName = `${uploadedFiles[index].fileName}.${mfileExtn}`;
                            fileAttachment['originalFileName'] = mfileName;
                            fileAttachment['originalName'] = mfileName;
                            fileAttachment['newFileName'] = mfileName;
                            this.initFileUpload(uploadedFiles[index], fileIndex, fileLen, fileAttachment, i);
                            break;
                        }
                        setTimeout(() => {
                          scount++;
                        }, 500);
                      });
                      //sflag = (this.existingFileIndex.lengh == scount) ? true : false;
                      if(sflag) {
                        let timeout = (this.initFileUpload) ? 1000 : this.existingFileIndex.length*500;
                        if(emitFlag) {
                          setTimeout(() => {
                            this.existingFileIndex = [];
                            this.existingFileAttachment = [];
                            this.existingFiles = [];
                            this.existingUploadFiles = [];
                            this.checkingMedia = false;
                            this.attachmentView = true;
                            this.fileLoading = !this.attachmentView;
                            if(!this.instantUpload) {
                              let uploadItems = {
                                action: 'upload',
                                items: this.uploadedFiles,
                                attachments: this.attachments,
                                postData: this.postData,
                              };
                              console.log(uploadItems);
                              this.uploadedItems.emit(uploadItems);
                            } else {
                              let uploadItems = {
                                action: 'save',
                                items: emitMediaItems
                              };
                              console.log(uploadItems)
                              this.uploadedItems.emit(uploadItems)
                              setTimeout(() => {
                                emitMediaItems = [];
                              }, 100);
                            }
                          }, timeout);
                        }
                        modalRef.dismiss('Cross click');
                      }
                      break;
                    case 'close':
                      this.existingFileIndex.forEach(index => {
                        let fileIndex = index+1;
                        this.filesArr.currentFiles.splice(fileIndex, 1);
                        setTimeout(() => {
                          scount++;
                        }, 50);
                      });
                      if(sflag) {
                        setTimeout(() => {
                          this.existingFileIndex = [];
                          this.existingFileAttachment = [];
                          this.existingFiles = [];
                          this.existingUploadFiles = [];
                        }, 500);
                        modalRef.dismiss('Cross click');
                      }
                      break;
                  }

                });
              }, 100);
            }, 1500);
          }
        });
      } else {
        this.attachmentView = true;
        this.fileLoading = !this.attachmentView;
        this.initFileUpload(file, fileIndex, fileLen, fileAttachment, i);
      }
      i++;
    }
  }

  // Init Media File Upload
  initFileUpload(file, fileIndex, fileLen, fileAttachment, itemIndex) {
    console.log(fileIndex, fileLen);
    //fileIndex += 1;
    let flag = true;
    let fileType = file.type.split('/');
    let fileExtn = file.name.split('.').pop();
    let localUrl = '';
    console.log(fileType)
    let fileTypeVar = fileType[0];
    let extFile = fileExtn.toLowerCase();
    if(extFile == 'heic') {
      fileTypeVar = 'heic';
    }
    
    switch (fileTypeVar) {
      case 'image':
        //console.warn('Size in bytes was:', this.imageCompress.byteCount(file));
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event: any) => {
          localUrl = event.target.result;
          this.compressFile(fileType[0], fileAttachment, file, localUrl, fileIndex, fileLen, itemIndex);
        };

        break;
      case 'video':
        flag = this.validateFileSize(fileType[0], file.size);
        fileAttachment['bulkFile'] = (parseInt(MediaTypeSizes.videoCheckSize) < file.size) ? true : false;
        fileAttachment['flagId'] = 2;
        file.bulkFile = fileAttachment['bulkFile'];
        setTimeout(() => {
          let vidSize = this.fileSizeTxt;
          if (!flag) {
            this.setErrMsg(file.name, vidSize);
          } else {
            let blobURL = URL.createObjectURL(file);
            fileAttachment['videoFilePath'] = blobURL;
            if(this.instantUpload) {
              this.compressFile(fileType[0], fileAttachment, file, localUrl, fileIndex, fileLen, itemIndex);
            } else {
              // Setup Uploaded Files
              this.setupUploadedFiles(fileAttachment, file, fileIndex, fileLen, itemIndex);
            }            
          }
        }, 500);
        break;
      case 'audio':
        flag = this.validateFileSize(fileType[0], file.size);
        fileAttachment['flagId'] = 3;
        setTimeout(() => {
          let audSize = this.fileSizeTxt;
          if (!flag) {
            this.setErrMsg(file.name, audSize);
          } else {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event: any) => {
              let localUrl = event.target.result;
              fileAttachment['audioFilePath'] = localUrl;
            };
            fileAttachment['thumbFilePath'] = `${this.mediaPath}/audio-medium.png`;
            if(this.instantUpload) {
              this.compressFile(fileType[0], fileAttachment, file, localUrl, fileIndex, fileLen, itemIndex);
            } else {
              // Setup Uploaded Files
              setTimeout(() => {
                this.setupUploadedFiles(fileAttachment, file, fileIndex, fileLen, itemIndex);
              }, 500);
            }
          }
        }, 500);
        break;
      default:
        flag = this.validateFileSize(fileType[0], file.size);
        console.log(fileType);
        fileAttachment['flagId'] = (fileType[1] == 'pdf' || fileType[1] == 'PDF') ? 4 : 5;
        setTimeout(() => {

          let docSize = this.fileSizeTxt;
          if (!flag) {
            this.setErrMsg(file.name, docSize);
          } else {
            let docThumb;
            let ext = fileExtn.toLowerCase();
            console.log(ext)
            switch (ext) {
              case 'pdf':
                docThumb = 'pdf-medium';
                break;
              case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
              case 'xlsx':
              case 'xls':
                docThumb = 'xls-medium';
                break;
              case 'docx':
              case 'doc':
              case 'msword':
                docThumb = 'doc-medium';
                break;
              case 'vnd.openxmlformats-officedocument.presentationml.presentation':
              case 'pptx':
              case 'ppt':
                docThumb = 'ppt-medium';
                break;
              case 'txt':
                docThumb = 'txt-medium';
                break;
              case 'x-zip-compressed':
              case 'zip':
                docThumb = 'zip-medium';
                break;
              case 'exe':
                docThumb = 'exe-medium';
                break;
              case 'csv':
                docThumb = 'csv-medium';
                break;
              case 'html':
                docThumb = 'html-thumb-medium';
                break;
              case 'dat':
	              docThumb = 'dat-medium';
	              break;
              default:
                docThumb = 'unknown-thumb';
                break;
            }
            
            fileAttachment['fileExtension'] = fileExtn;

            console.log('initFileUpload =======> : ', {ext, mediaConvertFlagOthers: this.mediaConvertFlagOthers});
            if(ext == 'heic' && this.mediaConvertFlagOthers){
               console.log('initFileUpload mediaConvertFlagOthers=======> : ', this.mediaConvertFlagOthers);
              fileAttachment['thumbFilePath'] = "assets/images/landing-page/loading-more.svg";
              this.convertHEIC(file,fileAttachment);
              this.heicImageInterval = setInterval(() => {
                console.log('initFileUpload heicImageConverted=======> : ', this.heicImageConverted);
                if(this.heicImageConverted){
                  this.heicImageConverted = false;
                  console.log(this.imageUrl);
                  fileAttachment['thumbFilePath'] = this.imageUrl;
                  fileAttachment['heicImage'] = '1';
                  setTimeout(() => {
                     console.log("initFileUpload fileAttachment=======> : ",fileAttachment);
                     clearInterval(this.heicImageInterval); 
                     this.setupUploadedFiles(fileAttachment, file, fileIndex, fileLen, itemIndex);                     
                  }, 100);                 
                }                 
              }, 2000);              
            }
            else{
              fileAttachment['thumbFilePath'] = `${this.mediaPath}/${docThumb}.png`;
              if(this.instantUpload) {
                this.compressFile(fileType[0], fileAttachment, file, localUrl, fileIndex, fileLen, itemIndex);
              } else {
                // Setup Uploaded Files
                this.setupUploadedFiles(fileAttachment, file, fileIndex, fileLen, itemIndex);             
              }
            }
            
            
            
          }
        }, 500);
        break;
    }

    console.log(flag);
    setTimeout(() => {
      if (!flag) {
        this.filesArr.currentFiles.splice(fileIndex, 1);
        console.log(fileLen);
        console.log(fileAttachment);
        if (fileLen == 1 || (fileLen > 1 && (fileIndex + 1) == fileLen)) {
          this.attachmentView = true;
          this.fileLoading = !this.attachmentView;
          let uploadItems = {
            action: 'upload',
            items: this.uploadedFiles,
            attachments: this.attachments,
            postData: this.postData,
            file: file
          };
          this.uploadedItems.emit(uploadItems);
        }
      }
    }, 100);
  }

  // Compress Image
  compressFile(fileType, fileAttachment, file, image, fileIndex = -1, fileLen, itemIndex) {
    switch(fileType) {
      case 'image':
        let compressFile = true; 
        let orientation = -1;
        console.warn('file.size before compress:', this.commonApi.niceBytes(file.size));       
        let originalImageSize = file.size;
        let ratio = 100; // 👈 keep resolution intact
        let quality = 90;  // default high quality 
        if (originalImageSize>1000000 && originalImageSize <= 2000000) {
          ratio = 80;          
          quality = 40;
          let fileExtn = file.name.split('.').pop();
          let extFile = fileExtn.toLowerCase();
          if(extFile == 'png'){
            ratio = 60;
          }
          //console.warn('ratio:',ratio);
          //console.warn('quality:',quality);
        } else if (originalImageSize > 2000000) {
          ratio = 80;          
          quality = 50;
          let fileExtn = file.name.split('.').pop();
          let extFile = fileExtn.toLowerCase();
          if(extFile == 'png'){            
            ratio = 60;
            quality = 50;
          }
          //console.warn('ratio:',ratio);
          //console.warn('quality:',quality);
        } 
        else{
          compressFile = false;
        }          
        if(compressFile){   
          this.imageCompress.compressFile(image, orientation, ratio, quality).then(result => {
            //console.log(result);
            let imgResultAfterCompress = result;
            let base64str = imgResultAfterCompress.substring(result.indexOf(',') + 1)
            let sizeOFCompressedImage:any = atob(base64str).length;
            //console.warn('Size in bytes after compression:', sizeOFCompressedImage);
            console.warn('file.size after compress:', this.commonApi.niceBytes(sizeOFCompressedImage));
            // call method that creates a blob from dataUri
            let compressImg = imgResultAfterCompress.split(',');
            //console.log(compressImg);
            const imageBlob = this.dataURItoBlob(compressImg);
            //console.log(imageBlob);
            let flag = this.validateFileSize(fileType, sizeOFCompressedImage);
            fileAttachment['flagId'] = 1;
            //console.log(flag);
            setTimeout(() => {
              let imgSize = this.fileSizeTxt;
              if (!flag) {
                this.setErrMsg(file.name, imgSize);
              } else {
                console.log(file);
                fileAttachment['fileSize'] = sizeOFCompressedImage;
                fileAttachment['thumbFilePath'] = (imgResultAfterCompress != undefined) ? imgResultAfterCompress : `${this.mediaPath}/image-thumb.png`;
                const imageFile = new File([imageBlob], file.name, {type: file.type});
                imageFile['captionFlag'] = file.captionFlag;
                imageFile['fileCaption'] = file.fileCaption;
                imageFile['displayOrder'] = file.displayOrder;
                console.log(imageFile);
                console.log(fileAttachment);
                // Setup Uploaded Files
                this.setupUploadedFiles(fileAttachment, imageFile, fileIndex, fileLen, itemIndex);
              }
            }, 500);
          });
        }
        else{
          fileAttachment['flagId'] = 1;
          console.log(file);
          fileAttachment['thumbFilePath'] = (image != undefined) ? image : `${this.mediaPath}/image-thumb.png`;
          console.log(fileAttachment);
          // Setup Uploaded Files
          this.setupUploadedFiles(fileAttachment, file, fileIndex, fileLen, itemIndex);
        }
        break;
      default:
        // Setup Uploaded Files
        setTimeout(() => {
          this.setupUploadedFiles(fileAttachment, file, fileIndex, fileLen, itemIndex);
        }, 500);
        break;  
    }
  }

  // Setup Uploaded Files
  setupUploadedFiles(fileAttachment, file, fileIndex, fileLen, itemIndex = -1) {
    this.loadingUploadImageInit = false;
    this.setupInitFile++;
    console.log(fileAttachment['flagId']);
    /*if(fileAttachment['flagId'] < 6) {
      let fileSize = this.commonApi.niceBytes(file.size);
      fileAttachment['fileSize'] = fileSize;
    }*/
    fileAttachment['fileSizeOriginal'] = fileAttachment['fileSize'];
    fileAttachment['fileSize'] = this.commonApi.niceBytes(fileAttachment['fileSize']);    
    this.uploadedFiles.push(file);
    console.log(this.uploadedFiles);
    fileAttachment['filePath'] = fileAttachment['heicImage'] == '1' ? fileAttachment['filePath'] : file['thumbFilePath'];
    fileAttachment['videoFilePath'] = fileAttachment['videoFilePath'];
    let fa = fileAttachment['videoFilePath'];
    fa = this.sanitizer.bypassSecurityTrustResourceUrl(fa);
    fileAttachment['videoFilePath_att'] = fa;
    fileAttachment['audioFilePath'] = fileAttachment['audioFilePath'];
    fileAttachment['uploadStatus'] = 0;
    this.attachments.push(fileAttachment);
    console.log(fileIndex, itemIndex, fileLen, this.attachments);
    let viewFlag = (itemIndex < 0 || (itemIndex >= 0 && (itemIndex) == fileLen)) ? true : false;
    if (viewFlag) {
      setTimeout(() => {
        this.attachmentView = true;
        this.fileLoading = !this.attachmentView;
      }, 1000);
    }
    if (this.attachments.length > 1) {
      let checkArr = ['originalFileName'];
      let unique = this.commonApi.unique(this.attachments, checkArr);
      //this.attachments = unique;
    }
    let uploadItems = {
      action: 'upload',
      items: this.uploadedFiles,
      attachments: this.attachments,
      postData: this.postData,
      file: file
    };
    if(!this.instantUpload) {
      this.uploadedItems.emit(uploadItems);
    } else {
      if(this.setupInitFile == fileLen) {
        this.attachmentUpload();
        setTimeout(() => {
          this.setupInitFile = 0;
        }, 50);
      }
    }
  }

  dataURItoBlob(dataURI) {
    console.log(dataURI);
    const byteString = window.atob(dataURI[1]);
    const mimeString = dataURI[0].split(':')[1].split(';')[0];
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], {type: mimeString});
    return blob;
  }

  // Add Link
  addLink() {
    //console.log(132, this.attachments)
    //return false;

    if (this.apiData['access'] == 'video-library' && (this.attachments.length > 0 || (this.attachmentItems && this.attachmentItems.length > 0) )) {
      this.messageService.add({ severity: 'error', summary: 'You have already uploaded a video', closable: false, life: 2500 });
        return;
     }

    if (this.addLinkFlag) {
      this.apiUrl.attachmentLinkError = '';
      this.addLinkFlag = false;
      this.fileLoading = true;
      this.attachmentView = false;
      console.log(123, this.uploadedFiles);
      this.uploadFileLength = this.uploadedFiles.length;
      let displayOrder = this.apiData['displayOrder'] + 1;
      let type = 'link';
      let caption = '';
      let fileAttachment = [];
      fileAttachment['accessType'] = type;
      fileAttachment['accessTypeText'] = 'From PC';
      fileAttachment['flagId'] = 6;
      fileAttachment['fileId'] = 0;
      fileAttachment['fileType'] = type;
      fileAttachment['fileCaption'] = caption;
      fileAttachment['captionFlag'] = false;
      fileAttachment['url'] = '';
      fileAttachment['actionLink'] = 'new';
      fileAttachment['action'] = 'new';
      fileAttachment['valid'] = false;
      fileAttachment['selectedLang'] = [];
      fileAttachment['filteredLangItems'] = [];
      fileAttachment['filteredLangList'] = [];
      fileAttachment['progress'] = 70;
      fileAttachment['logo'] = `${this.mediaPath}/link-medium.png`;
      let isEstJob = (this.apiData['isEstJob'] && this.apiData['isEstJob'] != undefined) ? this.apiData['isEstJob'] : 0;
      fileAttachment['isEstJob'] = isEstJob;
      let file = {
        url: '',
        type: 'link',
        fileCaption: caption,
        filetype: 'link',
        flagId: 6,
        displayOrder: this.uploadFileLength + displayOrder
      };

      this.uploadedFiles.push(file);
      this.attachments.push(fileAttachment);
      console.log(this.attachments);
      setTimeout(() => {
        this.fileLoading = false;
        this.attachmentView = true;
      }, 500);
      if (this.attachments.length > 1) {
        let checkArr = ['originalFileName'];
        let unique = this.commonApi.unique(this.attachments, checkArr);
        //this.attachments = unique;
      }
      if(!this.instantUpload) {
        let uploadItems = {
          action: 'upload',
          items: this.uploadedFiles,
          attachments: this.attachments,
          postData: this.postData,
          file: file
        };
        this.uploadedItems.emit(uploadItems);
      }
    }
  }

  // Validate Max File Size
  public validateFileSize(type, size) {
    let flag;
    switch (type) {
      case 'image':
        flag = (this.imageSize < size) ? false : true;
        break;
      case 'video':
        flag = (this.videoSize < size) ? false : true;
        break;
      case 'audio':
        flag = (this.audioSize < size) ? false : true;
        break;
      default:
        flag = (this.docSize < size) ? false : true;
        break;
    }
    return flag;
  }

  // Set Error Message
  setErrMsg(fname, mSize) {
    this.customError.push({
      fileName: fname,
      maxSize: mSize
    });
  }

  // Remove Error Messae
  removeMessage(i) {
    this.customError.splice(i, 1);
  }

  // Attachment Action
  attachmentAction(data) {
    console.log(data);
    let action = 'upload';
    let actionFlag = false;
    let access = data.action;
    let i = data.index;
    switch (access) {
      case 'caption':
      case 'caption-link':
        this.attachments[i]['action'] = data.captionAction;
        this.attachments[i]['fileCaption'] = data.text;
        this.attachments[i]['captionFlag'] = data.flag;
        this.uploadedFiles[i]['fileCaption'] = data.text;
        this.uploadedFiles[i]['file'] = data.files;

        if (access == 'caption-link') {
          this.uploadedFiles[i]['url'] = data.url;
          this.addLinkFlag = data.valid;
          this.uploadedFiles[i]['valid'] = data.valid;
        }
        if(this.instantUpload && data.valid) {
          this.attachmentUpload();
        }
        break;
      case 'file-delete':
        action = 'delete';
        this.addLinkFlag = true;
        if (this.uploadedFiles[i].type != 'media' && this.uploadedFiles[i].flagId < 6) {
          this.filesArr?.currentFiles?.splice(i, 1);
        }
        if(this.loadingUploadImageInit){
          this.loadingUploadImageInit = false;
        }
        this.uploadedFiles.splice(i, 1);
        this.attachments.splice(i, 1);
        let fileData = {
          action: 'order',
          attachments: this.attachments,
          files: this.uploadedFiles
        };
        this.attachmentAction(fileData);
        break;

      case 'order':
        this.attachments = data.attachments;
        this.uploadedFiles = data.files;
        for (let a in this.attachments) {
          let order = this.apiData['displayOrder'] + parseInt(a);
          let index = this.uploadedFiles.findIndex(option => option.name == this.attachments[a].originalName);
          this.uploadedFiles[index].displayOrder = ++order;
        }
        console.log(this.uploadedFiles);
        break;
        case 'video-thumb-file':
          this.attachments[i]['posterImage'] = data.posterImage;
          this.attachments[i]['posterImageId'] = data.posterImageId;
          //this.uploadedFiles[i]['posterImage'] = data.posterImage;
          this.uploadedFiles[i]['posterImageId'] = data.posterImageId;
        break;
    }
    this.uploadedFiles = (this.uploadedFiles == undefined) ? [] : this.uploadedFiles;
    if (this.attachments.length > 1) {
      let checkArr = ['originalFileName'];
      let unique = this.commonApi.unique(this.attachments, checkArr);
      //this.attachments = unique;
    }
    if(!this.instantUpload) {
      let uploadItems = {
        action: action,
        items: this.uploadedFiles,
        attachments: this.attachments,
        postData: this.postData,
        actionFlag: actionFlag,
        itemIndex: i
      };
      this.uploadedItems.emit(uploadItems);
    }
  }

  // File upload
  async attachmentUpload() {
    localStorage.removeItem('jobPosted');
    let uploadItemsCount = 0;
    let uploadedFiles = [];
    let attachments = [];
    this.uploadedFiles.forEach((item, i) => {
      if (item.type != 'media') {
        uploadItemsCount++;
        uploadedFiles.push(this.uploadedFiles[i]);
        attachments.push(this.attachments[i]);
      }
    });
    this.uploadedFiles = uploadedFiles;
    this.attachments = attachments;
    console.log(this.uploadedFiles, this.attachments);
    //let uploadCount = this.uploadedFiles.length;
    let uploadCount = uploadItemsCount;
    console.log(uploadCount);
    let bulkAccess = this.apiData['bulkUpload'];
    let bulkFlag = (bulkAccess == 'undefined' || bulkAccess == undefined) ? false : bulkAccess;
    let i = 0;
    for (let u in this.uploadedFiles) {
      let accessType = this.attachments[u]['accessType'];
      if (accessType == 'upload' || accessType == 'link') {
        //this.currentFile = this.uploadedFiles[u];
        //this.attachments[u].push(this.apiData);
        this.attachments[u]['access'] = this.apiData['access'];
        this.attachments[u]['apiKey'] = this.apiData['apiKey'];
        this.attachments[u]['domainId'] = this.apiData['domainId'];
        this.attachments[u]['countryId'] = this.apiData['countryId'];
        this.attachments[u]['userId'] = this.apiData['userId'];
        this.attachments[u]['contentType'] = this.apiData['contentType'];
        this.attachments[u]['dataId'] = (bulkFlag) ? this.uploadedFiles[u]['dataId'] : this.apiData['dataId'];
        this.attachments[u]['displayOrder'] = this.uploadedFiles[u]['displayOrder'];
        this.attachments[u]['uploadCount'] = uploadCount;
        this.attachments[u]['uploadFlag'] = true;
        this.attachments[u]['processFlag'] = false;

        if(this.pageAccess == 'gtsr') {
          this.attachments[u]['procedureId'] = this.apiData['procedureId'];
          this.attachments[u]['processId'] = this.apiData['processId'];
          this.attachments[u]['gtsId'] = this.apiData['gtsId'];
        }
        if(this.pageAccess == 'workorder') {
          this.attachments[u]['threadId'] = this.apiData['threadId'];
          this.attachments[u]['postId'] = this.apiData['postId'];
          this.attachments[u]['workOrderId'] = this.apiData['workOrderId'];
        }
        if(this.pageAccess == 'instant-est-job') {
          this.attachments[u]['workOrderId'] = this.apiData['dataId'];
        }
        if(this.pageAccess == 'workorder-page') {
          this.attachments[u]['workOrderId'] = this.apiData['workOrderId'];
          if((this.apiData['threadId']!= undefined && this.apiData['threadId'] > 0) || (this.apiData['approvedFlag']=='1' && this.apiData['threadId']!= undefined))
          {
            this.attachments[u]['threadId'] = this.apiData['threadId'];
          }
          if((this.apiData['postId']!= undefined && this.apiData['postId'] > 0) || (this.apiData['approvedFlag']=='1' && this.apiData['postId']!= undefined))
          {
            this.attachments[u]['postId'] = this.apiData['postId'];
          }
        }
        if(this.pageAccess == 'welcome-message') {
          this.attachments[u]['fromWelcomeMessage'] = this.apiData['fromWelcomeMessage'];
        }
        if(this.pageAccess == 'presets') {
          this.attachments[u]['presetId'] = this.apiData['presetId'];
        }
        if(this.pageAccess == 'damaged-vehicle') {
          this.attachments[u]['locationId'] = this.apiData['locationId'];
        }
        let size = this.uploadedFiles[u].size;
        //this.totalSizeToUpload = size;
        this.totalSizeToUpload = this.calculateTotalSize();
        //this.attachments[u]['progress'] = 0;
        console.log(this.attachments[u]);
        this.attachmentProgress = true;
        if (!this.attachments[u].cancelFlag) {
          await this.uploadFile(i, u, this.attachments[u], this.uploadedFiles[u], uploadCount);
          i++;
        }
      }
    }
  }

  // Upload File
  async uploadFile(index, findex, fileInfo, attachment, uploadCount) {
    console.log(fileInfo);
    console.log(attachment);
    console.log(this.pageAccess, this.apiData);
    //let i = parseInt(index)+1;
    let i = parseInt(index) + 1;
    //let uploadLen = this.uploadedFiles.length;
    let uploadLen = uploadCount;
    let totalTemp = 0;
    let fileType = this.attachments[findex]['flagId'];
    //this.totalSizeToUpload -= attachment.size;

    if (this.pageAccess == 'video-library') {
    /* Video duration get */
    const video = document.createElement('video');
    video.src = window.URL.createObjectURL(attachment);
    video.preload = 'metadata';

    // Await the video duration before proceeding with the upload
    await new Promise<void>((resolve, reject) => {
      video.onloadedmetadata = () => {
        console.log('video source', video.src);
        console.log('video length', video.duration);
        fileInfo['fileDuration'] = video.duration;
        resolve(); // Resolve once the video duration is set
      };

      video.onerror = () => {
        reject(new Error('Video metadata could not be loaded.'));
      };
    });
  }

   
   this.upload(this.pageAccess,index, findex, fileInfo, attachment, uploadCount);

  }

  // Upload File
  upload(access,index, findex, fileInfo, attachment, uploadCount) {
    console.log(access)
    console.log(fileInfo)
    console.log(attachment)
    let newFileName = (fileInfo.newFileName && fileInfo.newFileName != undefined) ? fileInfo.newFileName : '';
    let mediaId = (fileInfo.mediaId && fileInfo.mediaId != undefined) ? fileInfo.newFileName : 0;
    const mformData: FormData = new FormData();
    const formData: FormData = new FormData();
    formData.append('apiKey', fileInfo.apiKey);
    formData.append('domainId', fileInfo.domainId);
    formData.append('countryId', fileInfo.countryId);
    formData.append('userId', fileInfo.userId);
    formData.append('contentId', fileInfo.contentId);
    formData.append('workstreamId', fileInfo.workstreamId);
    formData.append('uploadByAuthor', fileInfo.uploadByAuthor);
    formData.append('userInputId', fileInfo.userInputId);
    formData.append('newFileName', newFileName);
    formData.append('mediaId', mediaId);
    if(fileInfo.posterImageId){
      formData.append('posterImageId', fileInfo.posterImageId);
    }
    if(fileInfo.isEstJob && fileInfo.isEstJob != undefined){
      formData.append('isEstJob', fileInfo.isEstJob);
    }
    let uploadType = (fileInfo.uploadType == undefined || fileInfo.uploadType == 'undefined') ? 'upload' : fileInfo.uploadType;
    fileInfo.displayOrder = (fileInfo.displayOrder == undefined || fileInfo.displayOrder == 'undefined') ? 0 : fileInfo.displayOrder;
    if(access != 'module' && access != 'adas' && access != 'dtc' && access != 'escalation-export') {
      let defaultLanguage = JSON.parse(localStorage.getItem('defaultLanguage'));
      //let langId = (access != 'media' && fileInfo.filteredLangItems && fileInfo.filteredLangItems.length > 0) ? fileInfo.filteredLangItems : [defaultLanguage[0].id];
      let langId = (access != 'media' && fileInfo.filteredLangItems && fileInfo.filteredLangItems.length > 0) ? fileInfo.filteredLangItems : '';
      let caption = fileInfo.fileCaption;
      fileInfo.fileCaption = (caption == undefined || caption == 'undefined') ? '' : caption;

      formData.append('uploadCount', fileInfo.uploadCount);
      formData.append('uploadFlag', fileInfo.uploadFlag);
      formData.append('type', fileInfo.fileType)
      formData.append('caption', fileInfo.fileCaption);
      formData.append('linkUrl', fileInfo.linkUrl);
      formData.append('mediaId', fileInfo.mediaId);
      formData.append('isVideoCompressed', fileInfo.isVideoCompressed);
      if(access == 'workorder-page') {
        formData.append('workOrderId', fileInfo.workOrderId);
        if((fileInfo.threadId != undefined && fileInfo.threadId > 0) || (fileInfo.approvedFlag=='1' && fileInfo.threadId != undefined))
            {
              formData.append('threadId', fileInfo.threadId);
            }
      } else if (access == 'market-place') {
        formData.append('thread_id', fileInfo.dataId);
      } else {
        formData.append('threadId', access == 'manage-content-file-pdf' ? fileInfo.dataId : fileInfo.threadId);
      }
      formData.append('directAttachment', fileInfo.directAttachment);
      formData.append('postStatus', fileInfo.postStatus);
      formData.append('flagId', fileInfo.flagId);
      formData.append('postType', fileInfo.postType);
      formData.append('fileDuration', fileInfo.fileDuration);
      formData.append('compressionType', fileInfo.compressionType);
      formData.append('displayOrder', fileInfo.displayOrder);
      formData.append('language', langId && langId !='' ? JSON.stringify(langId) : '');
      if(access == 'gtsr') {
        formData.append('procedureId', fileInfo.procedureId);
        formData.append('processId', fileInfo.processId);
        formData.append('gtsId', fileInfo.gtsId);
      }

    }

      if(access == 'damaged-vehicle') {
          formData.append('locationId', fileInfo.locationId);
      }

    if(uploadType == 'audio') {
      formData.append('flagId', fileInfo.flagId);
      formData.append('fileDuration', fileInfo.fileDuration);
    }

    if(access == 'dtc') {
      formData.append('action', fileInfo.action);
      formData.append('type', fileInfo.type);
      formData.append('type_name', fileInfo.typeName);
      formData.append('type_id', fileInfo.typeId);
    }

    if(access == 'workorder') {
      //formData.append('threadId', fileInfo.threadId);
      //formData.append('postId', fileInfo.postId);
      formData.append('workOrderId', fileInfo.workOrderId);
    }

    if(access == 'adasCalproReport') {
      formData.append('isAdasReport', '1');
    }



    if(access == 'welcome-message') {
      formData.append('fromWelcomeMessage', fileInfo.fromWelcomeMessage);
    }

    if(access == 'userprofile-page' || access == 'tool-banner-upload') {
      formData.append('dataId', fileInfo.dataId);
      formData.append('contentTypeId', fileInfo.contentType);
    }
     if(access == 'tool-document-page') {
      formData.append('dataId', fileInfo.dataId);
      formData.append('contentTypeId', fileInfo.contentType);
    }


      if(access == 'manage-content-file-pdf' && fileInfo.deleteFileId && fileInfo.deleteFileId != undefined) {
        formData.append('deleteFileId', fileInfo.deleteFileId);
      }
      if(access == 'manage-content-file-pdf' && fileInfo.typeId && fileInfo.typeId != undefined) {
        formData.append('typeId', fileInfo.typeId);
      }
    
    if(access == 'module' || access == 'adas') {
      mformData.set('apikey', fileInfo.apiKey);
      mformData.set('domainId', fileInfo.domainId);
      mformData.set('userId', fileInfo.userId);
      mformData.set('apikey', fileInfo.apiKey);
      mformData.set('action', fileInfo.action);
      mformData.set('type', fileInfo.type);
      mformData.set('typeId', fileInfo.typeId);
      mformData.set('deleteFlag', fileInfo.deleteFlag);
      mformData.append('file', attachment);
    }

    formData.append('platform', '3');

    switch (access) {
      case 'media':
      /* if((this.mediaConvertFlag && (this.attachments[findex]['flagId'] == 2 || this.attachments[findex]['flagId'] == 3)) || (this.mediaConvertFlagOthers)){
          this.serverUrl = this.apiUrl.uploadS3();
          formData.delete('file'); 
          formData.append('fileName', fileInfo.originalName);
          let fileSize = fileInfo.fileSizeOriginal;
          formData.append('fileSize', fileSize.toString());         
          //formData.append('fileId', fileInfo.fileId); 
          
          formData.append('dataId', fileInfo.dataId);
          formData.append('contentTypeId', fileInfo.contentType); 
          return this.fileUploadNew(formData,access,index, findex, fileInfo, attachment, uploadCount);        
        }
        else{*/
            this.serverUrl = this.apiUrl.apiGetUploadURL();
            if(fileInfo.type != 'link') {
              formData.append('file', attachment);
            } else {
              formData.append('linkUrl', fileInfo.url)
            }
            formData.append('dataId', fileInfo.dataId);
            formData.append('contentTypeId', fileInfo.contentType);
            /*new Response(formData).text().then(console.log)
            return;*/
            return this.fileUpload(formData,access,index, findex, fileInfo, attachment, uploadCount);          
        /*}*/
        break;
      case 'dtc':
        if(fileInfo.type != 'link') {
          formData.append('file', attachment);
        } else {
          formData.append('linkUrl', fileInfo.url)
        }
        this.serverUrl = this.apiUrl.apiGetCreateDTC();
        return this.fileUpload(formData,access,index, findex, fileInfo, attachment, uploadCount);
        break;
      case 'escalation-export':
        if(fileInfo.type != 'link') {
          formData.append('file', attachment);
        } else {
          formData.append('linkUrl', fileInfo.url)
        }
        //this.serverUrl = this.apiUrl.apiEscalationDealerImport();
        this.serverUrl = this.apiUrl.apiEscalationDealerImportValidate();
        return this.fileUpload(formData,access,index, findex, fileInfo, attachment, uploadCount);
        break;
      case 'module':
      case 'adas':
        if(fileInfo.type != 'link') {
          formData.append('file', attachment);
        } else {
          formData.append('linkUrl', fileInfo.url)
        }
        this.serverUrl = this.apiUrl.apiRepairifyImport();
        return this.fileUpload(mformData,access,index, findex, fileInfo, attachment, uploadCount);
        break;
      case 'tool-document-page':
        if((this.mediaConvertFlag && (this.attachments[findex]['flagId'] == 2 || this.attachments[findex]['flagId'] == 3)) || (this.mediaConvertFlagOthers && fileInfo.type != 'link')){
          this.serverUrl = this.apiUrl.uploadS3();
          formData.delete('file'); 
          formData.append('fileName', fileInfo.originalName);
          let fileSize = fileInfo.fileSizeOriginal;
          formData.append('fileSize', fileSize.toString());         
          //formData.append('fileId', fileInfo.fileId); 
          
          formData.append('dataId', fileInfo.dataId);
          formData.append('contentTypeId', fileInfo.contentType); 
          /*new Response(formData).text().then(console.log)
          return;*/
          // return this.fileUploadNew(formData,access,index, findex, fileInfo, attachment, uploadCount);        
          return this.fileUploadMultiPart(formData, access, index, findex, fileInfo, attachment, uploadCount);
        }
        else{
            if(fileInfo.type != 'link') {
              formData.append('file', attachment);
            } else {
              formData.append('linkUrl', fileInfo.url)
            }
            formData.append('dataId', fileInfo.dataId);
            formData.append('contentTypeId', fileInfo.contentType);
            /*new Response(formData).text().then(console.log)
            return;*/
            this.serverUrl = this.apiUrl.uploadAttachmentForRuntime();
            return this.fileUpload(formData,access,index, findex, fileInfo, attachment, uploadCount);          
        }
        break;
      case 'userprofile-page':
      case 'tool-banner-upload':
        if(fileInfo.type != 'link') {
          formData.append('file', attachment);
        } else {
          formData.append('linkUrl', fileInfo.url)
        }
        this.serverUrl = this.apiUrl.uploadAttachmentForRuntime();
        return this.fileUpload(formData,access,index, findex, fileInfo, attachment, uploadCount);
        break;
      case 'video-library':
        if((this.mediaConvertFlag && (this.attachments[findex]['flagId'] == 2 || this.attachments[findex]['flagId'] == 3)) || (this.mediaConvertFlagOthers && fileInfo.type != 'link')){
          this.serverUrl = this.apiUrl.uploadS3();
          formData.delete('file'); 
          formData.append('fileName', fileInfo.originalName);
          let fileSize = fileInfo.fileSizeOriginal;
          formData.append('fileSize', fileSize.toString());         
          //formData.append('fileId', fileInfo.fileId); 
          
          formData.append('dataId', fileInfo.dataId);
          formData.append('contentTypeId', fileInfo.contentType); 
          /*new Response(formData).text().then(console.log)
          return;*/
          // return this.fileUploadNew(formData,access,index, findex, fileInfo, attachment, uploadCount);        
          return this.fileUploadMultiPart(formData, access, index, findex, fileInfo, attachment, uploadCount);
        }
        else{
            this.serverUrl = this.apiUrl.apiGetUploadURL();
            if(fileInfo.type != 'link') {
              formData.append('file', attachment);
            } else {
              formData.append('linkUrl', fileInfo.url)
            }
            formData.append('dataId', fileInfo.dataId);
            formData.append('contentTypeId', fileInfo.contentType);
            /*new Response(formData).text().then(console.log)
            return;*/
            return this.fileUpload(formData,access,index, findex, fileInfo, attachment, uploadCount);          
        }
      case 'market-place-survey':
        if((this.mediaConvertFlag && (this.attachments[findex]['flagId'] == 2 || this.attachments[findex]['flagId'] == 3)) || (this.mediaConvertFlagOthers && fileInfo.type != 'link')){
          this.serverUrl = this.apiUrl.uploadS3();
          formData.delete('file'); 
          formData.append('fileName', fileInfo.originalName);
          let fileSize = fileInfo.fileSizeOriginal;
          formData.append('fileSize', fileSize.toString());         
          //formData.append('fileId', fileInfo.fileId); 
          
          formData.append('dataId', fileInfo.dataId);
          formData.append('contentTypeId', fileInfo.contentType); 
          /*new Response(formData).text().then(console.log)
          return;*/
          // return this.fileUploadNew(formData,access,index, findex, fileInfo, attachment, uploadCount);        
          return this.fileUploadMultiPart(formData, access, index, findex, fileInfo, attachment, uploadCount);
        }
        else{
            this.serverUrl = this.apiUrl.apiGetUploadURL();
            if(fileInfo.type != 'link') {
              formData.append('file', attachment);
            } else {
              formData.append('linkUrl', fileInfo.url)
            }
            formData.append('dataId', fileInfo.dataId);
            formData.append('contentTypeId', fileInfo.contentType);
            /*new Response(formData).text().then(console.log)
            return;*/
            return this.fileUpload(formData,access,index, findex, fileInfo, attachment, uploadCount);          
        }
	    break;   
      case 'welcome-message':
         this.serverUrl = this.apiUrl.apiGetUploadURL();
            if(fileInfo.type != 'link') {
              formData.append('file', attachment);
            } else {
              formData.append('linkUrl', fileInfo.url)
            }
            formData.append('dataId', fileInfo.dataId);
            formData.append('contentTypeId', fileInfo.contentType);
            /*new Response(formData).text().then(console.log)
            return;*/
            return this.fileUpload(formData,access,index, findex, fileInfo, attachment, uploadCount);
        break;   
	default:
        if((this.mediaConvertFlag && (this.attachments[findex]['flagId'] == 2 || this.attachments[findex]['flagId'] == 3)) || (this.mediaConvertFlagOthers && fileInfo.type != 'link')){
          this.serverUrl = this.apiUrl.uploadS3();
          formData.delete('file'); 
          formData.append('fileName', fileInfo.originalName);
          let fileSize = fileInfo.fileSizeOriginal;
          formData.append('fileSize', fileSize.toString());         
          //formData.append('fileId', fileInfo.fileId); 
          
          formData.append('dataId', fileInfo.dataId);
          formData.append('contentTypeId', fileInfo.contentType); 
          /*new Response(formData).text().then(console.log)
          return;*/
          // return this.fileUploadNew(formData,access,index, findex, fileInfo, attachment, uploadCount);        
          return this.fileUploadMultiPart(formData, access, index, findex, fileInfo, attachment, uploadCount);
        }
        else{
            this.serverUrl = this.apiUrl.apiGetUploadURL();
            if(fileInfo.type != 'link') {
              formData.append('file', attachment);
            } else {
              formData.append('linkUrl', fileInfo.url)
            }
            formData.append('dataId', fileInfo.dataId);
            formData.append('contentTypeId', fileInfo.contentType);
            /*new Response(formData).text().then(console.log)
            return;*/
            return this.fileUpload(formData,access,index, findex, fileInfo, attachment, uploadCount);          
        }
        break;
        
    }
  }

  fileUpload(formData,access,index, findex, fileInfo, attachment, uploadCount){

     console.log(fileInfo);
    console.log(attachment);
    console.log(this.pageAccess, this.apiData);
    //let i = parseInt(index)+1;
    let i = parseInt(index) + 1;
    //let uploadLen = this.uploadedFiles.length;
    let uploadLen = uploadCount;
    let totalTemp = 0;
    let fileType = this.attachments[findex]['flagId'];

    return new Promise<void>(async (resolve, reject) => {
      this.uploadFlag =  await this.uploadService.fileUploadV2(this.serverUrl,formData).subscribe((event: HttpEvent<any>) => {
          //console.log(event);
          uploadLen = this.uploadedFiles.length;
          console.log(uploadLen);
          switch (event.type) {
            case HttpEventType.Sent:
              console.log('Request has been made!');
              break;
            case HttpEventType.ResponseHeader:
              console.log('Response header has been received!');
              break;
            case HttpEventType.UploadProgress:
              /*this.loadedSoFar = totalTemp + event.loaded;
              this.percentDone = Math.round(100 * this.loadedSoFar / this.totalSizeToUpload);
              console.log(index+'::'+this.percentDone)
              this.attachments[index]['progress'] = this.percentDone;
              console.log(`Uploaded! ${this.percentDone}%`);*/

              let progress = Math.round(100 * event.loaded / event.total);
              this.attachments[findex]['progress'] = progress;
              if (fileType == 1) {
                setTimeout(() => {
                  progress = 101;
                  this.attachments[findex]['progress'] = progress;
                }, 500);
              }
              console.log(`Uploaded! ${this.attachments[findex]['progress']}%`);
              break;
            case HttpEventType.Response:
              totalTemp = this.loadedSoFar;
              let mediaId = event.body.data.mediaId;
              let flag = (fileType == 2) ? false : true;
              console.log(`Uploaded So Far! ${this.loadedSoFar}%`);
              console.log(i + '::' + uploadLen);
              this.percentDone = (fileType == 2) ? 99 : 101;
              this.attachments[findex]['progress'] = this.percentDone;
              this.attachments[findex]['uploadStatus'] = 1;
              this.attachments[findex]['uploadStatusFlag']= 1; 
              if(this.pageAccess == 'gtsr' || this.pageAccess == 'instant-est-job') {
                this.gtsAttachmentResponse.push(event.body.data.fileAttachments);
              }
              if (fileType == 2) {
                let c = 0;
                let jobId = event.body.data.jobId;
                console.log(jobId, this.attachments[findex]);
                if (jobId != '') {
                  this.attachments[findex]['processFlag'] = true;
                  this.percentDone = 101;
                  this.attachments[findex]['progress'] = this.percentDone;
                  let intervalTimeOut = (this.attachments[findex]['bulkFile']) ? 60000 : 3000;
                  this.checkJobStatus(jobId, c, intervalTimeOut);
                  this.videoFlagInterval = setInterval(() => {
                    let chkVideoFlag: any = localStorage.getItem('jobPosted');
                    console.log(chkVideoFlag);
                    if (chkVideoFlag) {
                      this.jobStatusFlag.unsubscribe();
                      clearInterval(this.videoFlagInterval);
                      clearInterval(this.videoInterval);
                      localStorage.removeItem('jobPosted');
                      this.attachments[findex]['processFlag'] = false;
                      this.attachments[findex]['uploadStatusFlag']= 1;
                      console.log(`Uploaded So Far! ${this.loadedSoFar}%`);
                      console.log(i + '::' + uploadLen);
                      setTimeout(() => {
                        if (this.jobStatusFlag) {
                          this.jobStatusFlag.unsubscribe();
                          if (i != uploadLen) {
                            this.bulkUpdateSolr(fileInfo);
                          }
                        }
                      }, 1000);
                      if (i == uploadLen) {
                        this.jobStatusFlag.unsubscribe();
                        this.uploadCallbackNew(uploadLen);
                        //console.log(msg, event.body);
                      } else {
                        resolve();
                      }
                    }
                  }, intervalTimeOut);
                }
              }
              if (flag) {
                this.bulkUpdateSolr(fileInfo);
                if (i == uploadLen) {
                  this.uploadCallbackNew(uploadLen, mediaId, event.body.data);
                } else {
                  resolve();
                }
              }
              break;
          }
        },
        err => {
          this.progress = 0;
          //this.attachmentProgress = false;
          //this.attachmentView = true;
          //this.uploadCallback(0);
        });
    });

  }

  // File Upload
  fileUploadNew(formData,access,index, findex, fileInfo, attachment, uploadCount) {
    /*new Response(formData).text().then(console.log)
      return false;*/ 
      let i = parseInt(index) + 1;
      let stout = i == 1 ? 0 : (i * 2500) ;  
      setTimeout(() => { 
      console.log('stout',stout); 
      let fileType = this.attachments[findex]['flagId'];
      let uploadLen = this.uploadedFiles.length;
      let totalTemp = 0;
      this.serverUrl = this.apiUrl.uploadS3();
     
      console.log(fileInfo);      
      console.log(attachment);
      let thumbServerFileName = '';

    return new Promise<void>(async (resolve, reject) => {
        this.uploadFlag = await this.http.post<any>(`${this.serverUrl}`, formData).subscribe(
        (res) => {
            console.log(res.url);  
            console.log(res.mediaId); 
            let contentType=''; 
            thumbServerFileName = res.fileName;
            if(fileType == 2 || fileType == 3 ){
              this.attachments[findex]['thumbMediaId'] = res.mediaId;
              this.attachments[findex]['thumbDataId'] = fileInfo.dataId;
              contentType = fileInfo.contentType;                     
               console.log(this.attachments[findex]['thumbMediaId']);
               console.log(this.attachments[findex]['thumbDataId']);
               console.log(contentType);
               console.log(thumbServerFileName);
            }
            let file: any = File;
            file = attachment;
            console.log("attachment result:",res);       
            this.http.put(res.url, file, {
              // headers,
              reportProgress: true,
              observe: 'events'
            }).subscribe({
              next: event => {
                //console.log(event);  
                if (event.type === HttpEventType.UploadProgress && event.total) {
                  //this.progress = Math.round((event.loaded / event.total) * 100);
                  this.progress = Math.round(100 * event.loaded / event.total);
                  this.attachments[findex]['progress'] = this.progress;                  
                } else if (event.type === HttpEventType.Response) {                 
                  totalTemp = this.loadedSoFar;                  
                  let flag = (fileType == 2 || fileType == 3) ? false : true;
                  console.log(`Uploaded So Far! ${this.loadedSoFar}%`);
                  console.log(i + '::' + uploadLen);
                  this.percentDone = (fileType == 2 || fileType == 3) ? 99 : 101;
                  let originalFileName = this.attachments[findex]['originalFileName'];
                  //originalFileName = originalFileName.replace('undefined_','');
                  this.attachments[findex]['originalFileName'] = originalFileName;
                  this.attachments[findex]['progress'] = this.percentDone;
                  if(this.pageAccess == 'gtsr' || this.pageAccess == 'instant-est-job') {
                    console.log(res.fileAttachments);
                    this.gtsAttachmentResponse.push(res.fileAttachments);
                  }                  
                  let tout = ((parseInt(findex) + 1) * 10000);   
                  console.log(tout);            
                  if (fileType == 2 || fileType == 3) {
                    let c = 0;
                    setTimeout(() => {  
                        this.attachments[findex]['processFlag'] = true;
                        this.percentDone = 101;                        
                        this.attachments[findex]['progress'] = this.percentDone;   
                        let intervalTimeOut = (this.attachments[findex]['bulkFile']) ? 20000 : 10000 ;
                        this.checkJobStatusNew(c, intervalTimeOut, contentType, fileType, thumbServerFileName, findex);
                        this.attachments[findex]['videoFlagInterval'] = setInterval(() => {
                          let chkVideoFlag: any = localStorage.getItem('jobPosted_'+this.attachments[findex]['thumbMediaId']);
                          console.log(chkVideoFlag);
                          if (chkVideoFlag) {
                            if (this.attachments[findex]['jobStatusFlag']) {
                              this.attachments[findex]['jobStatusFlag'].unsubscribe();
                            }
                            clearInterval(this.attachments[findex]['videoFlagInterval']);
                            clearInterval(this.attachments[findex]['videoInterval']);
                            localStorage.removeItem('jobPosted_'+this.attachments[findex]['thumbMediaId']);
                            this.attachments[findex]['processFlag'] = false;
                            console.log(`Uploaded So Far! ${this.loadedSoFar}%`);
                            console.log(i + '::' + uploadLen);
                            setTimeout(() => {
                              //if (this.attachments && this.attachments[findex]['jobStatusFlag'] != undefined) {
                               // this.attachments[findex]['jobStatusFlag'].unsubscribe();
                                if (i != uploadLen) {
                                  this.bulkUpdateSolr(fileInfo);
                                }
                              //}
                            }, 1000);                             
                            //console.log(msg, event.body);
                            this.attachments[findex]['fileThumbprocessFlag'] = false;  
                            if (i == uploadLen) {
                              if (this.attachments[findex]['jobStatusFlag'] != undefined) {
                                this.attachments[findex]['jobStatusFlag'].unsubscribe();
                              }
                              this.uploadCallbackNew(uploadLen);
                              //console.log(msg, event.body);
                            } else {
                              resolve();
                            }                             
                             
                          }
                        }, intervalTimeOut);                      
                    }, tout);
                  }
                  if (flag) {                    
                    this.attachments[findex]['uploadStatusFlag']= 1;                    
                    this.bulkUpdateSolr(fileInfo);
                    if (i == uploadLen) {
                      let heicFlag = false;
                      this.attachments.forEach(citem => {
                        if(citem['heicImage'] == '1'){
                          heicFlag = true;
                        }
                      });
                       setTimeout(() => {
                        let tm  = heicFlag ? 5000 : 100;
                        setTimeout(() => {
                              this.uploadCallbackNew(uploadLen, this.attachments[findex]['thumbMediaId'], '');
                        }, tm);
                       }, 100);
                    } else {
                      resolve();
                    }
                  }                  
                }
              },
              error: err => {
                console.error('Upload failed:', err);
                this.successMsg = 'Upload failed.';
                this.progress = 0;
                this.attachments[index]['progress'] = this.progress;
              }
            });
          },
          /*error: err => {
            console.error('Failed to get pre-signed URL:', err);
            this.successMsg = 'Could not get upload URL.';
            this.progress = 0;
            this.attachments[index]['progress'] = this.progress;
          }*/
        );
      })
      }, stout);
  }


  fileUploadMultiPart(formData, access, index, findex, fileInfo, attachment, uploadCount) {
    /*new Response(formData).text().then(console.log)
      return false;*/
    let i = parseInt(index) + 1;
    let stout = i == 1 ? 0 : (i * 2500);
    setTimeout(() => {
      console.log('stout', stout);
      let fileType = this.attachments[findex]['flagId'];
      let uploadLen = this.uploadedFiles.length;
      let totalTemp = 0;
      this.serverUrl = this.apiUrl.uploadS3MultiPart('create-upload');
      const presignPartUrl = this.apiUrl.uploadS3MultiPart('presign-part');
      const completeUpload = this.apiUrl.uploadS3MultiPart('complete-upload');

      console.log(fileInfo);
      console.log(attachment);
      let thumbServerFileName = '';

      return new Promise<void>(async (resolve, reject) => {
        let file: any = File;
        file = attachment;
        formData.append('key', file.name);

        try {
          this.uploadFlag = await this.http.post<any>(`${this.serverUrl}`, formData).subscribe(
            async (res) => {
              const uploadId = res?.multipartRes?.UploadId;
              const key = res.multipartRes.Key;
              const mediaId = res?.mediaId;

              // 2. Loop over chunks
              const totalParts = Math.ceil(file.size / this.partSize);
              const uploadedPerPart: number[] = new Array(totalParts).fill(0);
              const parts: Array<{ PartNumber: number, ChecksumSHA256: string, etag: string }> = [];

              const updateProgress = () => {
                const uploaded = uploadedPerPart.reduce((a, b) => a + b, 0);
                let percent = Math.round((uploaded / file.size) * 100);
                if (percent > 99) percent = 99;
                this.attachments[findex]['progress'] = percent;
                this.progress = percent;
              };

              for (let i = 0; i < totalParts; i++) {
                const start = i * this.partSize;
                const end = Math.min(file.size, (i + 1) * this.partSize);
                const chunk = file.slice(start, end);

                // compute SHA256
                const checksum = await this.computeSHA256Base64(chunk);

                // get presigned URL for this part
                const presignResp = await fetch(`${presignPartUrl}`, {
                  method: 'POST',
                  body: new URLSearchParams({
                    key,
                    uploadId,
                    partNumber: (i + 1).toString(),
                    checksum,
                    flagId: fileInfo.flagId,
                    mediaId
                  })
                }).then(r => r.json());

                // upload chunk
                const etag: string = await new Promise((resolve, reject) => {
                  const xhr = new XMLHttpRequest();

                  xhr.open('PUT', presignResp.presignedUrl);
                  xhr.setRequestHeader('x-amz-checksum-sha256', checksum);

                  xhr.upload.onprogress = (e) => {
                    if (e.lengthComputable) {
                      uploadedPerPart[i] = e.loaded;
                      updateProgress();
                    }
                  };

                  xhr.onload = () => {
                    if (xhr.status >= 200 && xhr.status < 300) {
                      // Try different ETag capitalizations
                      const etag = xhr.getResponseHeader('ETag') || xhr.getResponseHeader('Etag') || '';   
                      console.log('etag', {etag, 1: xhr.getResponseHeader('ETag'), 2: xhr.getResponseHeader('Etag')});
                      
                      resolve(etag);
                    } else {
                      reject('Chunk upload failed');
                    }
                  };

                  xhr.onerror = () => reject('Network error');

                  xhr.send(chunk);
                });

                // store part info for completion
                parts.push({
                  PartNumber: i + 1,
                  ChecksumSHA256: checksum,
                  etag
                });
              }


              const completeResp = await fetch(`${completeUpload}`, {
                method: 'POST',
                body: JSON.stringify({
                  key,
                  uploadId,
                  parts,
                  flagId: fileInfo.flagId,
                  mediaId
                }),
                headers: {
                  'Content-Type': 'application/json'
                }
              }).then(r => r.json());

              console.log(res.url);
              console.log(res.mediaId);
              let contentType = '';
              thumbServerFileName = res.fileName;
              if (fileType == 2 || fileType == 3) {
                this.attachments[findex]['thumbMediaId'] = res.mediaId;
                this.attachments[findex]['thumbDataId'] = fileInfo.dataId;
                contentType = fileInfo.contentType;
                console.log(this.attachments[findex]['thumbMediaId']);
                console.log(this.attachments[findex]['thumbDataId']);
                console.log(contentType);
                console.log(thumbServerFileName);
              }
              console.log("attachment result:", res);

              totalTemp = this.loadedSoFar;
              let flag = (fileType == 2 || fileType == 3) ? false : true;
              console.log(`Uploaded So Far! ${this.loadedSoFar}%`);
              console.log(i + '::' + uploadLen);
              this.percentDone = (fileType == 2 || fileType == 3) ? 99 : 101;
              let originalFileName = this.attachments[findex]['originalFileName'];
              //originalFileName = originalFileName.replace('undefined_','');
              this.attachments[findex]['originalFileName'] = originalFileName;
              this.attachments[findex]['progress'] = this.percentDone;
              if (this.pageAccess == 'gtsr' || this.pageAccess == 'instant-est-job') {
                console.log(res.fileAttachments);
                this.gtsAttachmentResponse.push(res.fileAttachments);
              }
              let tout = ((parseInt(findex) + 1) * 10000);
              console.log(tout);
              if (fileType == 2 || fileType == 3) {
                let c = 0;
                setTimeout(() => {
                  this.attachments[findex]['processFlag'] = true;
                  this.percentDone = 101;
                  this.attachments[findex]['progress'] = this.percentDone;
                  let intervalTimeOut = (this.attachments[findex]['bulkFile']) ? 20000 : 10000;
                  this.checkJobStatusNew(c, intervalTimeOut, contentType, fileType, thumbServerFileName, findex);
                  this.attachments[findex]['videoFlagInterval'] = setInterval(() => {
                    let chkVideoFlag: any = localStorage.getItem('jobPosted_' + this.attachments[findex]['thumbMediaId']);
                    console.log(chkVideoFlag);
                    if (chkVideoFlag) {
                      if (this.attachments[findex]['jobStatusFlag']) {
                        this.attachments[findex]['jobStatusFlag'].unsubscribe();
                      }
                      clearInterval(this.attachments[findex]['videoFlagInterval']);
                      clearInterval(this.attachments[findex]['videoInterval']);
                      localStorage.removeItem('jobPosted_' + this.attachments[findex]['thumbMediaId']);
                      this.attachments[findex]['processFlag'] = false;
                      console.log(`Uploaded So Far! ${this.loadedSoFar}%`);
                      console.log(i + '::' + uploadLen);
                      setTimeout(() => {
                        //if (this.attachments && this.attachments[findex]['jobStatusFlag'] != undefined) {
                        // this.attachments[findex]['jobStatusFlag'].unsubscribe();
                        if (i != uploadLen) {
                          this.bulkUpdateSolr(fileInfo);
                        }
                        //}
                      }, 1000);
                      //console.log(msg, event.body);
                      this.attachments[findex]['fileThumbprocessFlag'] = false;
                      if (i == uploadLen) {
                        if (this.attachments[findex]['jobStatusFlag'] != undefined) {
                          this.attachments[findex]['jobStatusFlag'].unsubscribe();
                        }
                        this.uploadCallbackNew(uploadLen);
                        //console.log(msg, event.body);
                      } else {
                        resolve();
                      }

                    }
                  }, intervalTimeOut);
                }, tout);
              }
              if (flag) {
                this.attachments[findex]['uploadStatusFlag'] = 1;
                this.bulkUpdateSolr(fileInfo);
                if (i == uploadLen) {
                  let heicFlag = false;
                  this.attachments.forEach(citem => {
                    if (citem['heicImage'] == '1') {
                      heicFlag = true;
                    }
                  });
                  setTimeout(() => {
                    let tm = heicFlag ? 5000 : 100;
                    setTimeout(() => {
                      this.uploadCallbackNew(uploadLen, this.attachments[findex]['thumbMediaId'], '');
                    }, tm);
                  }, 100);
                } else {
                  resolve();
                }
              }
            },
          );
        } catch (err) {
          console.error('Failed to get pre-signed URL:', err);
          this.successMsg = 'Could not get upload URL.';
          this.progress = 0;
          this.attachments[index]['progress'] = this.progress;
        }
      })
    }, stout);
  }


  arrayBufferToBase64(buffer: ArrayBuffer): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const chunkSize = 0x8000; // 32KB chunks to avoid stack overflow
    for (let i = 0; i < bytes.length; i += chunkSize) {
      const chunk = bytes.subarray(i, i + chunkSize);
      binary += String.fromCharCode(...chunk);
    }
    return btoa(binary);
  }

  async computeSHA256Base64(blob: Blob): Promise<string> {
    const buffer = await blob.arrayBuffer();
    const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
    return this.arrayBufferToBase64(hashBuffer);
  }

  // Bulk upload solr update
  bulkUpdateSolr(fileInfo) {
    let bulkAccess = this.apiData['bulkUpload'];
    let bulkFlag = (bulkAccess == 'undefined' || bulkAccess == undefined) ? false : bulkAccess;
    if(bulkFlag)
    {
      console.log(fileInfo.dataId+'bulkFlag');
      let apiDatasocial = new FormData();
      apiDatasocial.append('apiKey', this.apiData['apiKey']);
      apiDatasocial.append('domainId', this.apiData['domainId']);
      apiDatasocial.append('threadId', fileInfo.dataId);
      apiDatasocial.append('userId', this.apiData['userId']);
      apiDatasocial.append('actionType', '2');
      apiDatasocial.append('action', 'create');
      this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { })
    }
  }

  // Check Job Status
  checkJobStatus(jobId, i, intervalTimeOut) {
    let data = {
      apiKey: this.apiData['apiKey'],
      jobId: jobId
    };
    this.jobStatusFlag = this.commonApi.checkJobStatus(data).subscribe((response: any) => {
      console.log(i, response.status, response.jobStatus);
      let jobStatus = response.jobStatus;
      if (response.jobStatus == 'Complete' || response.jobStatus == 'Error') {
        console.log(562)
        let flag: any = true;
        localStorage.setItem('jobPosted', flag);
      } else {
        i++;
        console.log(123)
        this.videoInterval = setInterval(() => {
          let chkVideoFlag: any = localStorage.getItem('jobPosted');
          console.log(456, chkVideoFlag);
          if (!chkVideoFlag) {
            clearInterval(this.videoInterval);
            if (this.jobStatusFlag) {
              this.jobStatusFlag.unsubscribe();
            }
            this.checkJobStatus(jobId, i, intervalTimeOut);
          }
        }, intervalTimeOut);
      }
    });
  }

   uploadCallbackNew(event, mediaId = 0, apiRes = '') {
    //if(this.mediaConvertFlag && this.mediaConvertFlagOthers){

          if (this.imageUrl && typeof this.imageUrl === 'string' && this.imageUrl.startsWith('blob:')) {
            URL.revokeObjectURL(this.imageUrl);
          }
           this.heicImageConverted = false;

       console.log("call");
      this.uploadProcesssInterval = setInterval(() => {
        let usf = 0;
        if(this.attachments && this.attachments.length){
          this.attachments.forEach(citem => {
            if(citem.uploadStatusFlag == 1){
                clearInterval(citem.videoInterval);
                if (citem.jobStatusFlag) {
                  citem.jobStatusFlag.unsubscribe();
                }
                usf++;
              }
          });
        }
        console.log(usf,this.attachments.length);
        if(this.attachments.length == usf){
            setTimeout(() => {
              console.log("clear");
              clearInterval(this.uploadProcesssInterval); 
              this.uploadCallback(event, mediaId, apiRes);                    
            }, 100);                 
          }                 
      }, 2000);
    /*}
    else{
        this.uploadCallback(event, mediaId, apiRes);  
    }*/

   }


  // Upload Callback
  uploadCallback(event, mediaId = 0, apiRes = '') {  
    this.uploadedFiles = [];
    this.attachments = [];
    this.attachmentProgress = false;
    this.attachmentView = false;
    this.successMsg = this.apiData['message'];
    this.commonApi.emitbugfeatureattachment(true);
    if(this.pageAccess != 'post' && this.pageAccess != 'workorder' && this.pageAccess != 'audit-workflow' && this.pageAccess != 'damaged-vehicle' && this.pageAccess != 'adasCalproReport'){
      this.msgModalRef = this.modalService.open(SuccessModalComponent, this.modalConfig);
      this.msgModalRef.componentInstance.successMessage = this.successMsg;
    }
    let timeout = (this.pageAccess == 'post' || this.pageAccess == 'workorder' || this.pageAccess != 'audit-workflow') ? 0 : 2000;
    setTimeout(() => {
      let threadAction = this.apiData['threadAction'];
      console.log(threadAction, this.pageAccess);
      if(this.pageAccess == 'instant-est-job') {
        this.gtsAttachmentResponse.forEach(citem => {
          citem['mediaId'] = citem.fileId;
          let fileExtn = citem.originalName.split('.').pop();
          citem['fileExtension'] = fileExtn;
          if(citem['flagId'] == 0 && (fileExtn == 'xls' || fileExtn == 'xlsx')) {
            citem['flagId'] = 5;
          }
        });
        let uploadItems = {
          action: 'save',
          items: this.gtsAttachmentResponse
        };
        console.log(uploadItems)
        this.uploadedItems.emit(uploadItems)
        setTimeout(() => {
          this.msgModalRef.dismiss('Cross click');
          this.gtsAttachmentResponse = [];
        }, 100);
        return false;
      }
      if(this.pageAccess == 'damaged-vehicle') {
        let damagedVehicleUploadItems = {
          action: 'upload',
          items: this.uploadedFiles,
          attachments: this.attachments,
          postData: this.postData
        };
        console.log(damagedVehicleUploadItems);
        this.uploadedItems.emit(damagedVehicleUploadItems);
        this.uploadComplete.emit(true);
        return false;
      }
      if (this.pageAccess != 'post' && this.pageAccess != 'workorder' && this.pageAccess != 'audit-workflow' && this.pageAccess != 'damaged-vehicle') {
        if (this.pageAccess != 'sib' && this.pageAccess != 'adasCalproReport') {
          this.msgModalRef.dismiss('Cross click');
        }
        //if(!this.teamSystem || (this.pageAccess != 'thread') || (this.pageAccess == 'thread' && threadAction == 'new')) {
        if (!this.teamSystem &&
            ((this.pageAccess != 'presets' && this.pageAccess != 'ro-payment-upload' && this.pageAccess != 'welcome-message' && this.pageAccess != 'tool-banner-upload' &&  this.pageAccess != 'userprofile-page' && this.pageAccess != 'tool-document-page' && this.pageAccess != 'workorder-page' &&  this.pageAccess != 'kaizen' && this.pageAccess != 'ppfr' && this.pageAccess != 'market-place' && this.pageAccess != 'market-place-survey' && this.pageAccess != 'video-library' && this.pageAccess != 'thread' && this.pageAccess != 'documents' && this.pageAccess != 'adas'  && this.pageAccess != 'adas-procedure' && this.pageAccess != 'parts' && this.pageAccess != 'knowledgearticles' && this.pageAccess != 'sib' && this.pageAccess != "bugorfeature" && this.pageAccess != "annoncements" && this.pageAccess != 'damaged-vehicle' && this.pageAccess != 'adasCalproReport') || ((this.pageAccess == 'thread' || this.pageAccess == 'knowledgearticles' || (this.pageAccess == 'sib' && this.actionIndex < 0))) && threadAction == 'new')) {
          this.windowClose();
        }
        let flag: any = true;
        if (threadAction == 'edit') {
          //localStorage.setItem('routeLoad', 'true');
        }
        switch (this.pageAccess) {
          case 'presets':
            setTimeout(() => {
            let apiDatasocial2 = new FormData();
            apiDatasocial2.append('apiKey', this.apiData['apiKey']);
            apiDatasocial2.append('domainId', this.apiData['domainId']);
            apiDatasocial2.append('threadId', this.apiData['presetId']);
            apiDatasocial2.append('userId', this.apiData['userId']);
            apiDatasocial2.append('actionType', '9');
            let atype = (threadAction == 'edit') ? 'update' : 'create';
            apiDatasocial2.append('action', atype);
            this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial2).subscribe((response: any) => { })
            },1);

            let data = {};
            data = {
              action: 'presets-upload',
              presetId: this.apiData['presetId'],
            };
            setTimeout(() => {
            this.commonApi.emitpresetsUpload(data);
            },1);
            break;
            case 'welcome-message':
              this.commonApi.emitWelcomemsgUpload(true);
            break;
            case 'ro-payment-upload':
              this.commonApi.emitpayROUpload(true);
            break;
          case 'workorder-page':
            console.log(this.apiData);

            setTimeout(() => {
              let apiDatasocial2 = new FormData();
              apiDatasocial2.append('apiKey', this.apiData['apiKey']);
              apiDatasocial2.append('domainId', this.apiData['domainId']);
              apiDatasocial2.append('workOrderId', this.apiData['workOrderId']);
              apiDatasocial2.append('userId', this.apiData['userId']);
              apiDatasocial2.append('actionType', '7');
              apiDatasocial2.append('action', 'create');
              this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial2).subscribe((response: any) => { })
              },300);
            if(this.apiData['approvedFlag']=='1')
            {
              setTimeout(() => {
              let apiDatasocial2 = new FormData();
              apiDatasocial2.append('apiKey', this.apiData['apiKey']);
              apiDatasocial2.append('domainId', this.apiData['domainId']);
              apiDatasocial2.append('threadId', this.apiData['threadId']);
              apiDatasocial2.append('postId', this.apiData['postId']);
              apiDatasocial2.append('userId', this.apiData['userId']);
              apiDatasocial2.append('actionType', '1');
              apiDatasocial2.append('action', 'create');
              this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial2).subscribe((response: any) => { })
              },300);
            }

            if(this.apiData['roPushApiFlag']) {
              setTimeout(() => {
                this.roPushApi(this.apiData['workOrderId'], this.apiData['shopId'], this.apiData['threadId'], this.apiData['postId'], this.apiData['assignTech']);
              }, 400);
            }

            let data1 = {};
            let assignFlag = this.apiData['assignFlag'];
            let dispatchId = this.apiData['dispatchId'];
            data1 = {
              action: 'workorder-upload',
              workOrderId: this.apiData['workOrderId'],
              assignFlag,
              dispatchId
            };
            //this.commonApi.emitworkorderUpload(data1);

            this.roUploadComplete.emit(data1);

              break;
          case 'tool-document-page':
            console.log(this.apiData);
            let data22 = {};
            data22 = {
              action: 'userprofile-upload',
              actiontype: this.apiData['actiontype'],
              uploload: true,
              dataId: this.apiData['dataId'],
            };
            console.log('tool-document-page','emit',data22)
            this.toolDocumentUploadComplete.emit(data22);
            console.log('tool-document-page','emit',data22)
            break;
        case 'userprofile-page':
            console.log(this.apiData);
            let data2 = {};
            data2 = {
              action: 'userprofile-upload',
              actiontype: this.apiData['actiontype'],
              uploload: true,
              dataId: this.apiData['dataId'],
            };
            this.commonApi.emitUserProfileUpload(data2);
            break;
          case 'tool-banner-upload':
            this.uploadedFiles = [];
            this.attachments = [];
            let uploadItems1 = {
              action: 'upload',
              items: this.uploadedFiles,
              attachments: this.attachments,
              postData: this.postData
            };
            console.log(uploadItems1);           
            if (mediaId) {
              this.uploadedItems.emit({ uploadItems: uploadItems1, mediaId: mediaId, attachments: this.attachmentItems });
            } else {
              this.uploadedItems.emit(uploadItems1);
            }
            let fileData = {
              action: 'order',
              attachments: this.attachments
            };
            console.log(fileData);
            this.attachmentAction(fileData);
            break;
          case 'gtsr':
            let uploadItems = {
              action: 'submit',
              items: [],
              fileArr: [],
              attachments: [],
              response: this.gtsAttachmentResponse
            };
            this.gtsApi.fileDatas.items = [];
            this.gtsApi.fileDatas.attachments = []
            this.uploadedItems.emit(uploadItems);
            setTimeout(() => {
              this.gtsAttachmentResponse = [];
            }, 100);
            return false;
            break;
          case 'ppfr':
            if (this.teamSystem) {
              window.open(this.pageAccess, IsOpenNewTab.teamOpenNewTab);
            } else {

              let domainId = localStorage.getItem('domainId');
              let platformId = localStorage.getItem('platformId');
              let TVSIBDomain: boolean = false;
              TVSIBDomain = (platformId == '2' && domainId == '97') ? true : false;
              if (TVSIBDomain) {
                window.opener.location.reload();
                setTimeout(() => {
                  this.msgModalRef.dismiss('Cross click');
                  window.close();
                }, 1000);
              } else {
                if (threadAction == 'ppfr-page') {
                  window.close();
                } else {
                  this.router.navigate([this.pageAccess]);
                }
                window.opener.location.reload();
              }
            }
            break;
            case 'kaizen':
              if (this.teamSystem) {
                window.open(this.pageAccess, IsOpenNewTab.teamOpenNewTab);
              } else {
                if(threadAction == 'new') {
                  //window.close();
                } else {
                  this.router.navigate([this.apiData['navUrl']]);
                }
                window.opener.location.reload();
              }
              break;
          case 'annoncements':
            //window.opener.location = `${this.pageAccess}/dashboard`;
            if (threadAction == 'new') {
              /*
              let apiDatasocial = new FormData();
              apiDatasocial.append('apiKey', this.apiData['apiKey']);
              apiDatasocial.append('domainId', this.apiData['domainId']);
              apiDatasocial.append('threadId', this.apiData['dataId']);
              apiDatasocial.append('userId', this.apiData['userId']);
              apiDatasocial.append('actionType', '15');
              apiDatasocial.append('action', 'create');
              this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { })
              */
              this.ancApi.announcementPush(this.pushData).subscribe((response) => {
              });
              this.windowClose();
              window.opener.location.reload();
            } else {
              /*
              let apiDatasocial = new FormData();
              apiDatasocial.append('apiKey', this.apiData['apiKey']);
              apiDatasocial.append('domainId', this.apiData['domainId']);
              apiDatasocial.append('threadId', this.apiData['dataId']);
              apiDatasocial.append('userId', this.apiData['userId']);
              apiDatasocial.append('actionType', '15');
              apiDatasocial.append('action', 'update');
              this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { })
              */
             
             if( this.apiData['sendNotification'] == "1"){
               this.ancApi.announcementPush(this.pushData).subscribe((response) => {
              });
             }
              localStorage.setItem('viewAnc', flag);
              let url = `announcements/view/${this.apiData['dataId']}`;
              this.router.navigate([url]);
            }
            break;
          case 'bugorfeature':
              if(this.teamSystem) {
                this.router.navigate([this.apiData['navUrl']]);
              } else {
                if(threadAction == 'edit') {
                  localStorage.setItem("editNav",flag)
                  localStorage.setItem('viewKB', flag);
                  let url = `bug_and_features/view/${this.apiData['threadId']}`;
                  this.router.navigate([url]);

                } else {
                  this.windowClose();
                  window.opener.location.reload();
                }
              }
            break;
          case 'parts':
            console.log(this.apiData['navUrl']);
            if(this.apiData['solrApi']) {
              let partSolrApiData = this.apiData['apiDataSocial'];
              this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", partSolrApiData).subscribe((response: any) => { })
            }

            if (threadAction == 'edit') {
              //localStorage.setItem('viewPart', flag);
              this.router.navigate([this.apiData['navUrl']]);
            } else {
              let url = (threadAction == 'duplicate') ? RedirectionPage.Parts : this.apiData['navUrl'];
              //this.threadApi.threadPush(this.apiData['pushFormData']).subscribe((response) => {});
              this.router.navigate([url]);
            }
            break;
          case 'documents':
            let durl = this.apiData['navUrl'];
            if (this.teamSystem) {
              window.open(durl, IsOpenNewTab.teamOpenNewTab);
            } else {
              let notificationAction = this.apiData['notificationAction'];
              let approveNotificationAction = this.apiData['approveNotificationAction'];
              console.log('pushData: ' + this.pushData);
              console.log('notificationAction: ' + notificationAction);
              let apiDatasocial = new FormData();
              apiDatasocial.append('apiKey', this.apiData['apiKey']);
              apiDatasocial.append('domainId', this.apiData['domainId']);
              apiDatasocial.append('threadId', this.apiData['dataId']);
              apiDatasocial.append('userId', this.apiData['userId']);
              apiDatasocial.append('actionType', '2');
              apiDatasocial.append('action', 'create');
              this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { })
              if (notificationAction) {
                this.threadApi.documentNotification(this.pushData).subscribe((response) => { });
              }
              if(approveNotificationAction){
                this.threadApi.documentApprovalNotification(this.approveStatusData).subscribe((response) => { });
              }
              if (threadAction == 'edit') {
                localStorage.setItem('viewDoc', flag);
                if (durl == 'documents') {
                  window.location.href = durl;
                } else {
                  this.router.navigate([durl]);
                }
              } else {

                let opt = localStorage.getItem('documentViewOption');
                  console.log(opt);
                  if(opt == '2'){
                    setTimeout(() => {
                      console.log(this.apiData['dataId']);
                      this.viewMore(this.apiData['dataId']);
                    }, 200);
                  }
                  else{
                    this.windowClose();
                  }
                  window.opener.location.reload();
                  //window.opener.location = this.apiData['navUrl'];
              }
            }
            break;
          case 'adas-procedure':
            let apurl = this.apiData['navUrl'];
            if (this.teamSystem) {
              window.open(durl, IsOpenNewTab.teamOpenNewTab);
            } else {
              let notificationAction = this.apiData['notificationAction'];
              let solrAction = (threadAction == 'new') ? 'create' : 'update';
              let apiDatasocial = new FormData();
              apiDatasocial.append('apiKey', this.apiData['apiKey']);
              apiDatasocial.append('domainId', this.apiData['domainId']);
              apiDatasocial.append('threadId', this.apiData['dataId']);
              apiDatasocial.append('userId', this.apiData['userId']);
              apiDatasocial.append('actionType', this.apiData['solrType']);
              apiDatasocial.append('action', solrAction);
              this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { })
              setTimeout(() => {
                this.threadApi.adasNotification(this.pushData).subscribe((response) => {});
              }, 500);
              let adasTimeOut = (threadAction == 'edit') ? 3500 : 4500;
              if (threadAction == 'edit') {
                setTimeout(() => {
                  let newTab:any = localStorage.getItem('adasNavNewTab');
                  newTab = (newTab == null || newTab == 'null') ? false : newTab;
                  if(newTab) {
                    localStorage.removeItem('adasNavNewTab');
                    window.opener.location.reload();
                    this.windowClose();
                  } else {
                    localStorage.setItem('viewAdas', flag);
                    //window.opener.location.reload();
                    /* if (durl == RedirectionPage.AdasProcedure) {
                      window.location.href = durl;
                    } else {
                      this.router.navigate([durl]);
                    } */
                    this.router.navigate([durl]);
                  }
                }, adasTimeOut);
              } else {
                setTimeout(() => {
                  this.windowClose();
                  //window.opener.location = this.apiData['navUrl'];
                }, adasTimeOut);
              }
            }
            break;
          case 'thread':
            let url = 'threads';
            let notificationAction = this.apiData['notificationAction'];
            let approveNotificationAction = this.apiData['approveNotificationAction'];
            let apiDatasocial = new FormData();
            apiDatasocial.append('apiKey', this.apiData['apiKey']);
            apiDatasocial.append('domainId', this.apiData['domainId']);
            apiDatasocial.append('threadId', this.apiData['threadId']);
            apiDatasocial.append('postId', this.apiData['dataId']);
            apiDatasocial.append('userId', this.apiData['userId']);
            apiDatasocial.append('actionType', '1');
            apiDatasocial.append('action', 'create');
            this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { })
            let platformIdInfo = localStorage.getItem('platformId');
            if(platformIdInfo=='3')
            {
              this.baseSerivce.postFormData("forum", "SendtoZendeskfromTac", apiDatasocial).subscribe((response: any) => { })
            }
            if (threadAction == 'new') {
              if(notificationAction) {
                this.threadApi.threadPush(this.pushData).subscribe((response) => {
                });
              }
              if(approveNotificationAction) {
                this.threadApi.documentApprovalNotification(this.apiData['approveStatusData']).subscribe((response) => {});
              }
            } else {
              if(notificationAction) {
                this.threadApi.threadPush(this.pushData).subscribe((response) => {
                });
              }
              let viewPath = (this.collabticDomain && this.apiData['domainId'] == 336) ? forumPageAccess.threadpageNewV3 : forumPageAccess.threadpageNewV2;
              let view = (this.newThreadView) ? viewPath : forumPageAccess.threadpageNew;
              url = `${view}${this.apiData['threadId']}`;
            }

            if (threadAction == 'edit') {
              let platformId = localStorage.getItem('platformId');
              if(platformId == '1'){
                let apiDataEdit = new FormData();
                apiDataEdit.append('apiKey', this.apiData['apiKey']);
                apiDataEdit.append('domainId', this.apiData['domainId']);
                apiDataEdit.append('threadId', this.apiData['threadId']);
                apiDataEdit.append('postId', this.apiData['dataId']);
                apiDataEdit.append('userId', this.apiData['userId']);
                apiDataEdit.append('actionType', '1');
                apiDataEdit.append('action', 'thread-edit');
                this.threadPostService.sendPushtoMobileAPI(apiDataEdit).subscribe((response) => { console.log(response); });
              }
              this.router.navigate([url]);
            }
            break;
          case 'knowledgearticles':
            //new Response(this.pushData).text().then(console.log);
            this.threadApi.threadPush(this.pushData).subscribe((response) => { });
            let apiDatasocialKA = new FormData();
            apiDatasocialKA.append('apiKey', this.apiData['apiKey']);
            apiDatasocialKA.append('domainId', this.apiData['domainId']);
            apiDatasocialKA.append('threadId', this.apiData['threadId']);
            apiDatasocialKA.append('userId', this.apiData['userId']);
            apiDatasocialKA.append('actionType', '6');
            apiDatasocialKA.append('action', 'create');
            this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocialKA).subscribe((response: any) => { })
            if (this.teamSystem) {
              this.router.navigate([this.apiData['navUrl']]);
            } else {
              if (threadAction == 'edit') {
                //localStorage.setItem('viewKA', flag);
                let url = `knowledgearticles/view/${this.apiData['threadId']}`;
                setTimeout(() => {
                  this.router.navigate([url]);
                }, 2000);
              } else {
                //localStorage.setItem('kaPush', this.apiData['workstreams']);
                window.opener.location.reload();
              }
            }
            break;
          case 'knowledge-base':
            if (this.teamSystem) {
              this.router.navigate([this.apiData['navUrl']]);
            } else {
              if (threadAction == 'edit') {
                localStorage.setItem('viewKB', flag);
                let url = `knowledge-base/view/${this.apiData['threadId']}`;
                this.router.navigate([url]);
              } else {
                //this.kbApi.pushKB(this.pushData).subscribe((response) => {});
              }
            }
            break;
          case 'sib':
            if (this.actionIndex < 0) {
              this.attachmentProgress = false;
              if (this.teamSystem) {
                this.router.navigate([this.pageAccess]);
              } else {
                let apiDatasocialSIB = new FormData();
                apiDatasocialSIB.append('apiKey', this.apiData['apiKey']);
                apiDatasocialSIB.append('domainId', this.apiData['domainId']);
                apiDatasocialSIB.append('threadId', this.apiData['threadId']);
                apiDatasocialSIB.append('postId', this.apiData['dataId']);
                apiDatasocialSIB.append('userId', this.apiData['userId']);
                apiDatasocialSIB.append('actionType', '11');
                if (threadAction == 'edit') {
                  apiDatasocialSIB.append('action', 'updateSib');
                }
                else{
                  apiDatasocialSIB.append('action', 'create');
                }
                this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocialSIB).subscribe((response: any) => { });
                setTimeout(() => {
                  if (threadAction == 'edit') {
                    this.msgModalRef.dismiss('Cross click');
                    let url = `sib/view/${this.apiData['threadId']}`;
                    this.router.navigate([url]);
                  } else {
                    window.opener.location.reload();
                  }
                }, 100);
                //this.windowClose();
              }
            } else {
              this.uploadedFiles = [];
              this.attachments = [];
              this.attachmentView = false;
              this.fileLoading = false;
              setTimeout(() => {
                this.attachmentProgress = false;
                this.msgModalRef.dismiss('Cross click');
                let flag: any = true;
                localStorage.setItem('sibUpload', flag);
              }, 1500);
            }
            break;
          case 'market-place':
            let threadId = this.activatedRoute.snapshot.params['id'];
            if (threadId) {
              this.router.navigateByUrl('/market-place/view/'+threadId);
            } else {
              this.router.navigateByUrl('/market-place/training');
            }
            break;
          case 'video-library':
            let videoId = this.activatedRoute.snapshot.params['id'];
            let categoryId = this.apiData['categoryId'];
            if (videoId) {
              this.router.navigateByUrl(`/market-place/video-library/list/${categoryId}/detail/${videoId}`);
            } else {
              this.router.navigateByUrl(`/market-place/video-library/list/${categoryId}`);
            }
            break;
          case 'market-place-survey':
            this.surveyAttachments.emit(true);
            break;
          case 'adasCalproReport':
            let adasData = {
              res: apiRes,
              uploaded: true,
            }
            this.uploadComplete.emit(adasData);
            break;
        }
      } else {
        if(this.pageAccess == 'post'){
          let data = {};
          if (threadAction == 'edit') {
            data = {
              action: 'post-edit',
              postId: this.apiData['dataId'],
              nestedReply: this.apiData['nestedReply'],
              viewpage: this.apiData['viewpage'],
              parentPostId: this.apiData['parentPostId']
            };
            console.log(data);
            let platformId = localStorage.getItem('platformId');
            //if(platformId == '1'){
            // PUSH
              let pnData = new FormData();
              pnData.append('apiKey', this.apiData['apiKey']);
              pnData.append('domainId', this.apiData['domainId']);
              pnData.append('countryId', this.apiData['countryId']);
              pnData.append('userId', this.apiData['userId']);
              pnData.append('threadId', this.apiData['threadId']);
              pnData.append('parentPostId', this.apiData['parentPostId']);
              pnData.append('silentPush', '1');

              if(this.apiData['nestedReply'] != '1'){
                pnData.append('commentId', this.apiData['dataId']);
                pnData.append('action', 'comment-edit');
              }
              else{
                pnData.append('commentId', this.apiData['parentPostId']);
                pnData.append('replyId', this.apiData['dataId']);
                pnData.append('action', 'reply-edit');
              }
              this.threadPostService.sendPushtoMobileAPI(pnData).subscribe((response) => {});
            //}
            if(platformId == '1' || platformId == '3' || platformId == '2'){
              let tcrData = new FormData();
              console.log(this.apiData);
              tcrData.append('apiKey', this.apiData['apiKey']);
              tcrData.append('domainId', this.apiData['domainId']);
              tcrData.append('threadId', this.apiData['threadId']);
              tcrData.append('userId', this.apiData['userId']);
              //tcrData.append('commentId', this.apiData['commentId']);
              tcrData.append('action', 'replyCount');
              if(this.apiData['nestedReply'] != '1'){
                tcrData.append('commentId', this.apiData['dataId']);
              }
              else{
                tcrData.append('commentId', this.apiData['parentPostId']);
                tcrData.append('replyId', this.apiData['dataId']);
              }
            this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", tcrData).subscribe((response: any) => { })
            if(platformId=='3')
            {
              this.baseSerivce.postFormData("forum", "SendReplytoZendeskfromTac", tcrData).subscribe((response: any) => { })
            }
          }
          } else {
            // PUSH
            let pnData = new FormData();
            pnData.append('apiKey', this.apiData['apiKey']);
            pnData.append('domainId', this.apiData['domainId']);
            pnData.append('countryId', this.apiData['countryId']);
            pnData.append('userId', this.apiData['userId']);
            pnData.append('threadId', this.apiData['threadId']);
            pnData.append('parentPostId', this.apiData['parentPostId']);

            if(this.apiData['nestedReply'] != '1'){
              pnData.append('action', 'comment');
              pnData.append('commentId', this.apiData['dataId']);
            }
            else{
              pnData.append('action', 'reply');
              pnData.append('replyId', this.apiData['dataId']);
              pnData.append('postId', this.apiData['dataId']);
            }
            if(this.apiData['commentPostType'] == '2' || this.apiData['commentPostType'] == '1'){
              pnData.append('commentPostType', this.apiData['commentPostType']);
            }

            let summitFix = this.apiData['summitFix'];
            if (summitFix == '0') {
              this.commonApi.emitbugfeatureattachment(true)
              this.threadPostService.sendPushtoMobileAPI(pnData).subscribe((response) => {});
            }
            let platformId = localStorage.getItem('platformId');
            //if(platformId == '1' || platformId == '3' || (platformId == '2' && (this.apiData['domainId']==52 || this.apiData['domainId']==82 || this.apiData['domainId']==7))){
              let tcrData = new FormData();
              console.log(this.apiData);
              tcrData.append('apiKey', this.apiData['apiKey']);
              tcrData.append('domainId', this.apiData['domainId']);
              tcrData.append('threadId', this.apiData['threadId']);
              tcrData.append('userId', this.apiData['userId']);
              tcrData.append('commentId', this.apiData['commentId']);
              tcrData.append('action', 'replyCount');
              if(this.apiData['nestedReply'] == '1'){
              tcrData.append('replyId', this.apiData['replyId']);
              }
            this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", tcrData).subscribe((response: any) => {  });
            setTimeout(() => {
              if(this.apiData['nestedReply'] == '1'){
                if(this.apiUrl.replyUpdateFlag){
                  this.apiUrl.replyUpdateFlag = false;
                  this.apiUrl.replyUpdatedFlag = true;
                  setTimeout(() => {
                    this.apiUrl.replyUpdatedFlag = false;
                  }, 1000);
                }
              }
              else{
                if(this.apiUrl.commentUpdateFlag){
                  this.apiUrl.commentUpdateFlag = false;
                  this.apiUrl.commentUpdatedFlag = true;
                  setTimeout(() => {
                    this.apiUrl.commentUpdatedFlag = false;
                  }, 1000);
                }
              }
            }, 2000);
            if(platformId=='3')
            {
              this.baseSerivce.postFormData("forum", "SendReplytoZendeskfromTac", tcrData).subscribe((response: any) => { })
            }

          //}

          if((this.apiData['domainId'] == '338' || this.collabticAutoDomain) && this.apiData['closeStatus'] != 'yes'){
              let roBusinessInfoJsonArr = this.apiData['roBusinessInfoJsonArr'];
             // let statusFlag = (this.apiData['domainId'] == '338' || (roBusinessInfoJsonArr.length > 0 && (roBusinessInfoJsonArr[0].requestTypeId && parseInt(roBusinessInfoJsonArr[0].requestTypeId) == 1))) ? true : false;
              let statusFlag = (this.apiData['domainId'] == '338' || (roBusinessInfoJsonArr && roBusinessInfoJsonArr.length > 0 && (roBusinessInfoJsonArr[0].requestTypeId && parseInt(roBusinessInfoJsonArr[0].requestTypeId) == 1))) ? true : false;
              if(statusFlag) {
                let platform: any = 3;
                let appVersion: any = environment.webVersionCollabtic;
                let tcrData1 = new FormData();
                tcrData1.append('apiKey', this.apiData['apiKey']);
                tcrData1.append('domainId', this.apiData['domainId']);
                tcrData1.append('userId', this.apiData['userId']);
                tcrData1.append('id', this.apiData['workOrderId']);
                tcrData1.append('statusId', "4");
                tcrData.append('platform', platform);
                tcrData.append('appVersion', appVersion);
                this.repairOrderApi.changeStatusTicket(tcrData1).subscribe(res => { console.log});
              }
          }
            // PUSH
            data = {
              action: 'post-new',
              closeStatus: this.apiData['closeStatus'],
              postId: this.apiData['dataId'],
              nestedReply: this.apiData['nestedReply'],
              parentPostId: this.apiData['parentPostId']
            };
          }
          this.commonApi.emitPostData(data);
          this.uploadedFiles = [];
          this.attachments = [];
          let uploadItems = {
            action: 'upload',
            items: this.uploadedFiles,
            attachments: this.attachments,
            postData: this.postData
          };
          console.log(uploadItems);
          this.uploadedItems.emit(uploadItems);
          let fileData = {
            action: 'order',
            attachments: this.attachments
          };
          console.log(fileData);
          this.attachmentAction(fileData);
          //this.msgModalRef.dismiss('Cross click');
        }
        console.log(this.pageAccess)
          switch (this.pageAccess) {
              case 'workorder':
                  let apiDatasocial = new FormData();
                  apiDatasocial.append('apiKey', this.apiData['apiKey']);
                  apiDatasocial.append('domainId', this.apiData['domainId']);
                  apiDatasocial.append('workOrderId', this.apiData['workOrderId']);
                  apiDatasocial.append('userId', this.apiData['userId']);
                  apiDatasocial.append('action', 'create');
                  apiDatasocial.append('actionType', '7');
                  this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => {
                  });
                  if (this.apiData['domainId'] == 338) {
                      let apiDatasocialThread = new FormData();
                      apiDatasocialThread.append('apiKey', this.apiData['apiKey']);
                      apiDatasocialThread.append('domainId', this.apiData['domainId']);
                      apiDatasocialThread.append('threadId', this.apiData['threadId']);
                      apiDatasocialThread.append('postId', this.apiData['dataId']);
                      apiDatasocialThread.append('userId', this.apiData['userId']);
                      apiDatasocialThread.append('actionType', '1');
                      apiDatasocialThread.append('action', 'create');
                      this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocialThread).subscribe((response: any) => {
                      })
                      this.threadApi.threadPush(this.apiData['pushData']).subscribe((response) => {
                      });
                  }
                  this.commonApi.emitWorkorderData(true);
                  break;
              case 'audit-workflow':
                  this.uploadComplete.emit(this.apiData['formApiData']);
                  break;
              default:
                  this.uploadComplete.emit(true);

          }
      }
    }, timeout);
    console.log('File uploaded successfully created!', event.body);
    
  }

  // Cancel Upload
  cancelUpload(i) {
    let progress = this.attachments[i].progress;
    //if(progress == 0) {
    const modalRef = this.modalService.open(ConfirmationComponent, this.modalConfig);
    modalRef.componentInstance.access = 'Cancel Upload';
    modalRef.componentInstance.confirmAction.subscribe((receivedService) => {
      modalRef.dismiss('Cross click');
      console.log(receivedService);
      if (receivedService) {

        this.heicImageConverted = false;
        /*if(progress == 0) {
          //this.attachments[i].cancelFlag = true;
          this.attachments.splice(i, 1);
        }*/
        if (progress == 0) {
          this.uploadedFiles.splice(i, 1);
          this.attachments.splice(i, 1);
        }

        if (progress > 0 && this.attachments.length > 0) {
          this.uploadFlag.unsubscribe();
          console.log(i);
          console.log(this.attachments);
          console.log(this.uploadedFiles);
          //this.uploadFile(i, this.attachments[i], this.uploadedFiles[i]);
          this.attachmentUpload();
        }

        if (progress == 0 && this.attachments.length == 0) {
          this.attachmentProgress = false;
          this.attachmentView = true;
          this.uploadCallback(0);
        }

      }
    });
    /*} else {
      this.attachments.splice(i, 1);
      this.uploadFlag.unsubscribe();
    } */
  }

  // Convert File Size
  niceBytes(x) {
    let l = 0, n = parseInt(x, 10) || 0;

    while (n >= 1024 && ++l) {
      n = n / 1024;
    }
    //include a decimal point and a tenths-place digit if presenting
    //less than ten of KB or greater units
    return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + this.units[l]);
  }

  // Calculate Total File Size
  calculateTotalSize(): number {
    let total = 0;
    for (let i = 0; i < this.uploadedFiles.length; i++) {
      total += this.uploadedFiles[i].size;
    }
    return total;
  }

  // Video File Reader
  readVideo(fileAttachment, file) {
    let filePath;
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function(e) {
      filePath = e.target.result;
    };

    setTimeout(() => {
      // Setup Uploaded Files
      this.setupUploadedFiles(fileAttachment, file, -1, 0);
    }, 500);
  }

  tapOnMediaUpload(){
    console.log(this.apiData, this.attachmentItems, this.postData);
    let uf = [];
    this.uploadedFiles.forEach(item => {
      uf.push(item.fileId);
    });
    let mediaList = [];
    this.attachments.forEach(item => {
      mediaList.push(item.fileId);
    });
    let aitem = [];
    this.attachmentItems.forEach(item => {
      aitem.push(parseInt(item.fileId));
    });
    let data = {
      apiData: this.apiData,
      mediaList: mediaList,
      attachmentList: aitem,
      fileList: uf
    }
    this.commonApi.emitCloudTabData(data);
  }

  mediaApply(){
      let removedItems = this.cloudTabApplyData.mediaRemoveList;
      let mediaItems = this.cloudTabApplyData.mediaSelectionList;
      let access = this.apiData['access'];
      let postAttachments = [];
      console.log(access);
      let existItem = '';
      switch (access) {
        case 'thread':
          existItem = 'threadAttachments';
          break;
        case 'presets':
          existItem = 'presetsAttachments';
          break;
        case 'opportunity':
          existItem = 'opportunityAttachments';
          break;
        case 'documents':
          existItem = 'docAttachments';
          break;
        case 'knowledgearticles':
          existItem = 'knowledgeArticlesAttachments';
          break;
        case 'parts':
          existItem = 'partAttachments';
          break;
        case 'adas':
        case 'adas-procedure':
            existItem = 'adasAttachments';
            break;
        case 'post':
          console.log(this.postData);
          let postId = this.postData.postId;
          let threadId = this.postData.threadId;
          let threadPostText = `thread-post-${threadId}-attachments`;
          let postAttachmentItems: any = localStorage.getItem(threadPostText);
          postAttachmentItems = (postAttachmentItems) ? JSON.parse(postAttachmentItems) : [];
          let postIndex = postAttachmentItems.findIndex(option => option.id == postId);
          postAttachments = (postIndex < 0) ? [] : postAttachmentItems[postIndex].attachments;
          break;
      }
      let existingMediaItems = (access == 'post') ? postAttachments : JSON.parse(localStorage.getItem(existItem));
      let existIndex, action;
      console.log(existingMediaItems, mediaItems, removedItems);
      removedItems.forEach(rmitem => {
        let rmindex = this.attachments.findIndex(option => option.fileId == rmitem && option.accessType == 'media');
        //let rmId = rmitem.mediaId.toString();
        existIndex = -1;
        if (existingMediaItems != null) {
          existIndex = existingMediaItems.findIndex(option => option.fileId == rmitem);
        }
        console.log(rmitem, existIndex);
        if (rmindex >= 0 && existIndex < 0) {
          this.uploadedFiles.splice(rmindex, 1);
          this.attachments.splice(rmindex, 1);
        }

        if (existIndex >= 0) {
          action = 'remove';
          let data = {
            action: 'remove',
            postData: this.postData,
            media: rmitem
          };
          this.uploadedItems.emit(data);
        }
      });
      mediaItems.forEach(mitem => {
        let mindex = this.attachments.findIndex(option => option.fileId == mitem.mediaId);
        //let mId = mitem.mediaId.toString();
        existIndex = -1;
        if (existingMediaItems != null) {
          existIndex = existingMediaItems.findIndex(option => option.fileId == mitem.mediaId);
        }
        console.log(mitem, existIndex);
        if (mindex < 0 && existIndex < 0) {
          this.setupMediaUploadFiles(mitem);
        }

        if (existIndex >= 0) {
          let data = {
            action: 'insert',
            postData: this.postData,
            media: existingMediaItems[existIndex]
          };
          this.uploadedItems.emit(data);
        }
      });

  }

  mediaUpload() {

    if (this.apiData['access'] == 'video-library' && (this.attachments.length > 0 || (this.attachmentItems && this.attachmentItems.length > 0) )) {
      this.messageService.add({ severity: 'error', summary: 'You have already uploaded a video', closable: false, life: 2500 });
        return;
     }

    if (this.tvsDomain) {
      return false;
    }
    console.log(this.apiData, this.attachmentItems, this.postData);
    let mediaList = [];
    this.attachments.forEach(item => {
      mediaList.push(item.fileId);
    });
    let aitem = [];
    this.attachmentItems.forEach(item => {
      aitem.push(parseInt(item.fileId));
    });
    const modalRef = this.modalService.open(MediaUploadComponent, this.mediaConfig);
    modalRef.componentInstance.access = '';
    modalRef.componentInstance.apiData = this.apiData;
    modalRef.componentInstance.mediaList = mediaList;
    modalRef.componentInstance.attachmentList = aitem;
    modalRef.componentInstance.uploadAction.subscribe((receivedService) => {
      modalRef.dismiss('Cross click');
      if((this.apiData['access'] == 'market-place' && (this.apiData['domainId'] != 71 && this.apiData['domainId'] != 515) && this.apiData['trainingMode'] == "Recorded") || this.apiData['access'] == 'video-library' ) {
        let fileType = receivedService.mediaSelectionList[0].type.split('/');
        if(fileType[0] != 'video') {
          this.messageService.add({ severity: 'error', summary: 'Only videos are allowed', closable: false, life: 2500 });
          return
        };
       }
      let removedItems = receivedService.mediaRemoveList;
      let mediaItems = receivedService.mediaSelectionList;
      let access = this.apiData['access'];
      let postAttachments = [];
      console.log(access);
      let existItem = '';
      switch (access) {
        case 'thread':
          existItem = 'threadAttachments';
          break;
        case 'presets':
          existItem = 'presetsAttachments';
          break;
        case 'opportunity':
          existItem = 'opportunityAttachments';
          break;
        case 'documents':
          existItem = 'docAttachments';
          break;
        case 'knowledgearticles':
          existItem = 'knowledgeArticlesAttachments';
          break;
        case 'parts':
          existItem = 'partAttachments';
          break;
        case 'post':
          console.log(this.postData);
          let postId = this.postData.postId;
          let threadId = this.postData.threadId;
          let threadPostText = `thread-post-${threadId}-attachments`;
          let postAttachmentItems: any = localStorage.getItem(threadPostText);
          postAttachmentItems = (postAttachmentItems) ? JSON.parse(postAttachmentItems) : [];
          let postIndex = postAttachmentItems.findIndex(option => option.id == postId);
          postAttachments = (postIndex < 0) ? [] : postAttachmentItems[postIndex].attachments;
          break;
      }
      let existingMediaItems = (access == 'post') ? postAttachments : JSON.parse(localStorage.getItem(existItem));
      let existIndex, action;
      console.log(existingMediaItems, mediaItems, removedItems);
      removedItems.forEach(rmitem => {
        let rmindex = this.attachments.findIndex(option => option.fileId == rmitem && option.accessType == 'media');
        //let rmId = rmitem.mediaId.toString();
        existIndex = -1;
        if (existingMediaItems != null) {
          existIndex = existingMediaItems.findIndex(option => option.fileId == rmitem);
        }
        console.log(rmitem, existIndex);
        if (rmindex >= 0 && existIndex < 0) {
          this.uploadedFiles.splice(rmindex, 1);
          this.attachments.splice(rmindex, 1);
        }

        if (existIndex >= 0) {
          action = 'remove';
          let data = {
            action: 'remove',
            postData: this.postData,
            media: rmitem
          };
          this.uploadedItems.emit(data);
        }
      });
      mediaItems.forEach(mitem => {
        let mindex = this.attachments.findIndex(option => option.fileId == mitem.mediaId);
        //let mId = mitem.mediaId.toString();
        existIndex = -1;
        if (existingMediaItems != null) {
          existIndex = existingMediaItems.findIndex(option => option.fileId == mitem.mediaId);
        }
        console.log(mitem, existIndex);
        if (mindex < 0 && existIndex < 0) {
          this.setupMediaUploadFiles(mitem);
        }

        if (existIndex >= 0) {
          let data = {
            action: 'insert',
            postData: this.postData,
            media: existingMediaItems[existIndex]
          };
          this.uploadedItems.emit(data);
        }
      });
      let secElement = document.getElementById('step');
      setTimeout(() => {
        let scrollTop = secElement.scrollTop;
        setTimeout(() => {
          let scrollPos = scrollTop - 150;
          secElement.scrollTop = scrollPos;
        }, 200);
      }, 700);
    });
  }

  setupMediaUploadFiles(item, atype = '', binaryfile = null) {
    console.log(123, item, this.apiData, this.uploadedFiles);
    this.fileLoading = true;
    this.attachmentView = false;
    this.uploadFileLength = this.uploadedFiles.length;
    let displayOrder = this.uploadFileLength + 1;
    let type = 'media';
    let accessTypeText = 'Media Manager';
    let flagId = parseInt(item.flagId);
    let caption = item.fileCaption;
    let fileAttachment = [];
    fileAttachment['accessTypeText'] = accessTypeText;
    fileAttachment['accessType'] = type;
    fileAttachment['flagId'] = flagId;
    fileAttachment['fileId'] = item.mediaId;
    fileAttachment['fileType'] = item.fileType;
    fileAttachment['fileCaption'] = caption;
    fileAttachment['captionFlag'] = false;
    fileAttachment['url'] = '';
    fileAttachment['actionLink'] = 'new';
    fileAttachment['action'] = 'new';
    fileAttachment['valid'] = true;
    fileAttachment['selectedLang'] = [];
    fileAttachment['thumbFilePath'] = (atype == 'exists') ? item.thumbFilePath : item.fileImg;
    fileAttachment['fileSize'] = item.fileSize;
    fileAttachment['originalFileName'] = item.originalFileName;
    fileAttachment['originalName'] = item.originalFileName;
    fileAttachment['displayOrder'] = displayOrder;
    fileAttachment['progress'] = 30;
    fileAttachment['fileAction'] = 'file';
    fileAttachment['binaryfile'] = binaryfile;

    let language = item.languageOptions;
    console.log(language);
    let langId = [], langName = [];
    language.forEach(lang => {
      console.log(lang.id);
      langId.push(lang.id);
      langName.push(lang.name);
    });
    fileAttachment['filteredLangItems'] = langId;
    fileAttachment['filteredLangList'] = langName;
    fileAttachment['selectedLang'] = langName;

    switch (flagId) {
      case 2:
        console.log(465);
        if (atype == 'exists') {
          let lastDot = item.filePath.lastIndexOf('.');
          let vname = item.filePath.substring(0, lastDot);
          item.posterImage = `${vname}-thumb-00001.png`;
          item.videoUrl = item.filePath;
          fileAttachment['fileAction'] = 'media';
          console.log(item.posterImage);
        }
        let posterImage = item.posterImage;
        let videoUrl = item.videoUrl;
        fileAttachment['thumbFilePath'] = posterImage;
        fileAttachment['posterImage'] = posterImage;
        fileAttachment['videoFilePath'] = videoUrl;
        fileAttachment['videoUrl'] = (atype == 'exists') ? videoUrl : this.sanitizer.bypassSecurityTrustResourceUrl(videoUrl);
        break;
      case 6:
        let url = item.filePath;
        fileAttachment['logo'] = item.logo;
        fileAttachment['url'] = item.filePath;
        let aurl;
        let youtube = this.commonApi.matchYoutubeUrl(url);
        if (youtube) {
          item.linkType = 'youtube';
          aurl = `//www.youtube.com/embed/${youtube}`;
          fileAttachment['aurl'] = this.sanitizer.bypassSecurityTrustResourceUrl(aurl);
        }
        let vimeo = this.commonApi.matchVimeoUrl(url);
        if (vimeo) {
          item.linkType = 'video';
          aurl = `https://player.vimeo.com/video/${vimeo}`;
          fileAttachment['aurl'] = this.sanitizer.bypassSecurityTrustResourceUrl(aurl);
        }
        fileAttachment['fileType'] = item.linkType;
        break;
    }
    let file = {
      url: '',
      type: type,
      fileCaption: caption,
      filetype: item.fileType,
      flagId: item.flagId,
      displayOrder: displayOrder,
      name: item.originalFileName,
    };

    let newPosterImageId = flagId ==2 ?  item.posterImageId : '' ;
    let newPposterImage = flagId ==2 ?  item.posterImage : '' ;

    file['posterImageId'] = newPosterImageId;
    file['posterImage'] = newPposterImage;


    this.uploadedFiles.push(file);
    this.attachments.push(fileAttachment);
    console.log(this.uploadedFiles);
    console.log(this.attachments);

   // this.attachmentProgress = false;
    this.attachmentView = false;
    this.fileLoading = !this.attachmentView;
    setTimeout(() => {
      this.attachmentView = true;
      this.fileLoading = !this.attachmentView;

      let uploadItems = {
        action: 'upload',
        items: this.uploadedFiles,
        attachments: this.attachments
      };
      console.log(uploadItems);
      this.uploadedItems.emit(uploadItems);

    },750);


  }

  // Window Close
  windowClose() {
    setTimeout(() => {
      window.close();
    }, 200);
  }

  viewMore(docId){
    let navFrom = this.commonApi.splitCurrUrl(this.router.url);
    let wsFlag: any = (navFrom == ' documents') ? false : true;
    let scrollTop:any = 0;
    localStorage.setItem('docClosePage', "1");
    localStorage.setItem('docId', docId);
    localStorage.setItem('docIddetail', docId);
    localStorage.setItem('docInfoNav', 'true');
    this.commonApi.setListPageLocalStorage(wsFlag, navFrom, scrollTop);
	  let nav = `documents/view/${docId}`;
    console.log(nav);
	  this.router.navigate([nav]);
  }

  // GTS Runtime Upload
  gtsRuntimeUpload() {
    //console.log(this.apiData)
    this.attachmentUpload();
  }

  roPushApi(roId, shopId, threadId, postId, assignTech) {
    let fcmToken = localStorage.getItem('fcm_token');
    let pushFormData = new FormData();
    pushFormData.append('apiKey', this.apiData['apiKey']);
    pushFormData.append('domainId', this.apiData['domainId']);
    pushFormData.append('userId', this.apiData['userId']);
    pushFormData.append('deviceToken', fcmToken);
    pushFormData.append('roId', roId);
    pushFormData.append('threadId', threadId);
    pushFormData.append('postId', postId);
    pushFormData.append('shopId', shopId);
    pushFormData.append('workstreamsList', JSON.stringify(assignTech));

    this.LandingpagewidgetsAPI.cbtV3SendROPush(pushFormData).subscribe((response) => {
      console.log(response)
    });
  }

  // Get flag id
  getFlagId(file) {
    let fileType = file.type.split('/');
    let flagId;
    switch (fileType[0]) {
      case 'image':
        flagId = 1;
        break;
      case 'video':
        flagId = 2;
        break;
      case 'audio':
        flagId = 3;
        break;
      default:
        flagId = (fileType[1] == 'pdf' || fileType[1] == 'PDF') ? 4 : 5;
        break;
    }
    return flagId;
  }

       // Check Job Status
  checkJobStatusNew(i, intervalTimeOut, contentType, flagId, thumbServerFileName, findex) {   
    console.log(i, intervalTimeOut);
    const formData: FormData = new FormData();
    formData.append('apiKey', this.apiData['apiKey']);
    formData.append('userId', this.apiData['userId']);
    let dealerCode = localStorage.getItem('dealerCode');
    if(dealerCode && dealerCode !=undefined && dealerCode != 'undefined'){
      formData.append('dealerCode', dealerCode);
    }
    formData.append('domainId', this.apiData['domainId']);
    formData.append('offset', "0");
    formData.append('limit', "20");
    formData.append('fileName', thumbServerFileName);
    formData.append('flagId', flagId);
    formData.append('contentTypeId', contentType);

    //return false;

    this.attachments[findex]['jobStatusFlag'] = this.commonApi.checkJobStatusS3(formData).subscribe((response: any) => {
      console.log(i, response.status, response.jobStatus);
      console.log(thumbServerFileName,this.attachments[findex]['thumbMediaId']);
      let jobStatus = response.jobStatus;
      if (jobStatus.toLowerCase() == 'complete' || jobStatus.toLowerCase() == 'error') {
        console.log(789)
        let flag: any = true;
        localStorage.setItem('jobPosted_'+this.attachments[findex]['thumbMediaId'], flag);         
        this.attachments[findex]['uploadStatusFlag']= 1;
      } else {
        i++;
        console.log(123)
        this.attachments[findex]['videoInterval'] = setInterval(() => {
          let chkVideoFlag: any = this.attachments && this.attachments.length>0 ? localStorage.getItem('jobPosted_'+this.attachments[findex]['thumbMediaId']) : true;
          console.log(456, chkVideoFlag);
          if (!chkVideoFlag) {
            clearInterval(this.attachments[findex]['videoInterval']);
            if (this.attachments[findex]['jobStatusFlag']) {
              this.attachments[findex]['jobStatusFlag'].unsubscribe();
            }
            this.checkJobStatusNew(i, intervalTimeOut, contentType, flagId, thumbServerFileName, findex);
          }
        }, intervalTimeOut);
      }
    });
  }

    // Upload Callback
    uploadVideoCallback(event, mediaId = 0, apiRes = '',thumbnail = false,findex, fileInfo, attachment) { 
      this.attachments[findex]['fileThumbprocessFlag'] = true; 
      this.attachments[findex]['uploadedThumbItems']= []; 
      this.attachments[findex]['uploadedThumbItems'].push(this.uploadedFiles[findex]);
      console.log(this.attachments[findex]['uploadedThumbItems']);
      if(this.attachments[findex]['uploadedThumbItems'] && this.attachments[findex]['uploadedThumbItems'].length > 0) {
        this.attachments[findex]['videoThumbLoading'] = true;
        generateVideoThumbnails(this.attachments[findex]['uploadedThumbItems'][0], 5, 'base64')
        .then((thumbnails) => {
          // Handle the generated thumbnails
        console.log(thumbnails);
        
        // Loop over the thumbnails and add the index to the name
        let data = thumbnails.map((thumbnail, index) => {
          return {
            name: `videoThumb_${index + 1}`,  // Adding an index to the name
            img: thumbnail,        // Assuming the thumbnail data is stored here
          };
        });
          this.attachments[findex]['videoThumbnails'] = data;
          this.attachments[findex]['videoThumbLoading'] = false;
          this.attachments[findex]['selectedThumbnailIndex'] = 0;
        })
        .catch((error) => {
          console.error('Error generating thumbnails:', error);
        });
          
        const video = document.createElement('video');
        video.src = window.URL.createObjectURL(this.attachments[findex]['uploadedThumbItems'][0]);
        video.preload = 'metadata';
        video.onloadedmetadata = () => {
          console.log('video source', video.src);
          console.log('video length', video.duration);
          this.attachments[findex]['videoDuration'] = video.duration;
          console.log(this.attachments[findex]['videoDuration']);
        }
  
      } else {
        this.attachments[findex]['videoThumbLoading'] = false;
        this.attachments[findex]['selectedThumbnailIndex'] = null;
        this.attachments[findex]['videoThumbnails'] = null;
      }
  
  
    }

    selectThumbnail(index: number,findex: number) {         
      this.attachments[findex]['selectedThumbnailIndex'] = index;
      this.attachments[findex]['thumbFilePath'] = this.attachments[findex]['videoThumbnails']['img'] == undefined ? `${this.mediaPath}/video-medium.png` : this.attachments[findex]['videoThumbnails']['img'];
      if (this.attachments[findex]['videoThumbnails'] && this.attachments[findex]['videoThumbnails'].length > 0) {  
        let image = this.attachments[findex]['videoThumbnails'][this.attachments[findex]['selectedThumbnailIndex']];
        console.log(image)
        let file1 = this.base64ToFile(image?.img, image?.name);
        let arr = [];     
        console.log(file1);
        let file: any = File;
        file = file1;
        console.log(file);
        //arr.push(file);
        //console.log(arr);

       this.initThumbOnUpload(file,findex);
      } 
   }

   initThumbOnUpload(arr,findex){
        
        this.attachments[findex]['fileThumbProgress'] = 0;
        const file = arr;
        //const fileName = `${Date.now()}_${file.name}`;
        let fileName = file.name;
        fileName = fileName.replace('undefined_',''); 
        const contentType = file.type;
        let fileSize = this.commonApi.niceBytes(file.size);
        this.attachments[findex]['thumbFileSize'] = fileSize;
        this.attachments[findex]['thumbUploadStatus'] = 0;
    
        const formData: FormData = new FormData();
        formData.append('apiKey', this.apiData['apiKey']);
        formData.append('domainId', this.apiData['domainId']);
        formData.append('countryId', this.apiData['countryId']);
        formData.append('userId', this.apiData['userId']);
        formData.append('type', contentType);
        formData.append('fileSize', fileSize);
        formData.append('flagId', '1');
        formData.append('fileName', fileName);      
        formData.append('fileId', '0');
        formData.append('videoId', this.attachments[findex]['thumbMediaId']);
        formData.append('contentTypeId', '1000'); 
        formData.append('dataId', this.attachments[findex]['thumbDataId']);
        formData.append('thumbnail', "1"); 
        
        this.serverUrl = this.apiUrl.uploadS3();
        let totalTemp = 0;

        return new Promise<void>(async (resolve, reject) => {
        this.uploadFlag = this.http.post<any>(`${this.serverUrl}`, formData).subscribe(
        (res) => {
            console.log(res.url);  
            console.log(res.mediaId);  
            let file: any = File;
            file = arr;
            console.log(res.url,file);       
            this.http.put(res.url, file, {
              // headers,
              reportProgress: true,
              observe: 'events'
            }).subscribe({
              next: event => {
                //console.log(event);  
                if (event.type === HttpEventType.UploadProgress && event.total) {
                  //this.progress = Math.round((event.loaded / event.total) * 100);
                  let progress = Math.round(100 * event.loaded / event.total);
                  this.attachments[findex]['fileThumbProgress'] = progress;
                } else if (event.type === HttpEventType.Response) {                 
                  totalTemp = this.loadedSoFar;                  
                  let flag = true;
                  console.log(`Uploaded So Far! ${this.loadedSoFar}%`);
                  let percentDone = 101;
                  this.attachments[findex]['fileThumbProgress'] = percentDone;
                  let originalFileName = fileName;
                  this.attachments[findex]['thumbFileName'] = originalFileName;    
                  if (flag) {
                    this.attachments[findex]['fileThumbprocessFlag'] = false; 
                    this.attachments[findex]['thumbUploadStatus'] = 1; 
                    let pgItem1 = 0;                    
                    let pgItem2 = 0;                    
                    let videoFile = 0;                    
                    this.attachments.forEach(item => { 
                      if(item.uploadStatus == 1){
                        pgItem1++; 
                      }
                      if(item.flagId == 2){
                        videoFile++;
                        if(item.thumbUploadStatus == 1){
                          pgItem2++; 
                        }
                      }
                      if(pgItem1 == this.attachments.length && pgItem2 == videoFile){
                        this.uploadCallback(1,res.mediaId,'');
                      }
                    });            
                  }                  
                }
              },
              error: err => {
                console.error('Upload failed:', err);
                this.successMsg = 'Upload failed.';
                this.attachments[findex]['fileThumbProgress'] = 0;
              }
            });
          },
          /*error: err => {
            console.error('Failed to get pre-signed URL:', err);
            this.successMsg = 'Could not get upload URL.';
            this.progress = 0;
            this.attachments[index]['progress'] = this.progress;
          }*/
        );
      })

      
   }


     base64ToFile(base64Data: string, name = 'image'): File {
  const base64String = base64Data.replace(/^data:image\/\w+;base64,/, '');
  const binaryString = atob(base64String);
  const length = binaryString.length;
  const arrayBuffer = new ArrayBuffer(length);
  const uint8Array = new Uint8Array(arrayBuffer);

  for (let i = 0; i < length; i++) {
    uint8Array[i] = binaryString.charCodeAt(i);
  }

  // Check the raw bytes of the first few bytes (magic numbers)
  const magicNumber = uint8Array.slice(0, 4);  // Grab the first 4 bytes

  // Compare the first few bytes with known image magic numbers (as numbers)
  let mimeType = 'unknown';
  let extension = '';

  if (magicNumber[0] === 0xFF && magicNumber[1] === 0xD8) {
    mimeType = 'image/jpeg';
    extension = 'jpg';
  } else if (magicNumber[0] === 0x89 && magicNumber[1] === 0x50 && magicNumber[2] === 0x4E && magicNumber[3] === 0x47) {
    mimeType = 'image/png';
    extension = 'png';
  } else if (magicNumber[0] === 0x47 && magicNumber[1] === 0x49 && magicNumber[2] === 0x46 && magicNumber[3] === 0x38) {
    mimeType = 'image/gif';
    extension = 'gif';
  } else if (magicNumber[0] === 0x52 && magicNumber[1] === 0x49 && magicNumber[2] === 0x46 && magicNumber[3] === 0x46) {
    mimeType = 'image/webp';
    extension = 'webp';
  }

  // Create the Blob and File based on the detected MIME type
  const blob = new Blob([uint8Array], { type: mimeType });
  return new File([blob], `${name}.${extension}`, { type: mimeType });
   }

   public async onFileSelected(file: any,fileAttachment: any): Promise<void> {
    console.log(file);
    if (file) {
      

      // Check if the file is HEIC/HEIF
      if ((file?.type?.toLowerCase()?.includes('heic')|| file?.type === '') && (file.name.toLowerCase().endsWith('.heic') || file.name.toLowerCase().endsWith('.heif'))) {
        try {
          // Convert the HEIC blob to a web-compatible blob (e.g., JPEG)
          const convertedBlob: Blob = await heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.8,
          }) as Blob; // Cast to Blob for single image conversion

          // Create a URL for the converted image and display it
          this.imageUrl = URL.createObjectURL(convertedBlob);
          this.heicImageConverted = true;
        } catch (error) {
          console.error("Error converting HEIC image:", error);
          //alert("Could not convert the HEIC image.");
        }
      } else {
        // Handle non-HEIC images normally
        const reader = new FileReader();
        reader.onload = e => this.imageUrl = reader.result;
        reader.readAsDataURL(file);
      }
    }
  }
   
   convertHEIC(file,fileAttachment){
      this.onFileSelected(file,fileAttachment);
   }
}
